/*Developed by Gevorg Manukyan, Araks Yepremyan */

var animatetime = 500;
var __shop_social = [];
var _ajaxloadingpageid = 2;
var _productslistshow = 1;
var _loadingcollectionproducts = true;
var show_more_height;
var _wished_products_handles = [];
var block_height_resp;
var _shop_social_corusel;
$(document).ready(function () {
  if ($(".img_block5").length && window.innerWidth < 640) {
    $(".collections_block5:first-child .img_block5:not(.animated)")
      .addClass("animated fast")
      .addClass("slideInUpCustom");
  }

  function scrollCb() {
    var tiles = $(".img_block5:not(.animated)");
    var $window = $(window);
    var b = $window.scrollTop() + $window.height();

    tiles.each(function (i) {
      var $this = $(this);

      if (window.innerWidth > 640) {
        var a = $this.offset().top + $this.height() / 3;
      } else {
        var a = $this.offset().top + $this.height() / 4;
      }

      if (a < b) {
        console.log($this);
        $this.addClass("animated fast").addClass("slideInUpCustom");
      }
    });
  }

  $(window).scroll(function () {
    if ($(".img_block5").length) {
      scrollCb();
    }
  });

  $(".collection5_videos_block.video").on("click keypress", function (e) {
    e.preventDefault();

    if ($(this).data("videomp4") && $(this).data("videoogv")) {
      $(".info_popup_inner").html(
        '<video id="video_col5" tabindex="0" poster="" class="video-js vjs-default-skin vjs-16-9" autoplay controls>' +
          '<source src="' +
          $(this).data("videomp4") +
          '" class="mp4_v" type="video/mp4">' +
          '<source src="' +
          $(this).data("videoogv") +
          '" class="ogv_v" type="video/ogg">' +
          '<p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>' +
          "</video>"
      );
      if ($("#video_col5").length) {
        myPlayerc5 = videojs(
          "video_col5",
          { controls: true, autoplay: true, muted: false },
          function () {
            var player = this;
            player
              .on("ended", function () {
                this.play();
              })
              .on("seeking", function (e) {})
              .on("play", function (e) {})
              .on("pause", function (e) {});
          }
        );
        $(".col5video")
          .find(".popup_close")
          .click(function () {
            myPlayerc5.dispose();
          });
      }

      $(".popup_container").height($("#video_col5").innerHeight());

      $(".popup_blocks .info_popup").addClass("opened");
      $("body").addClass("y_hidden");
      $(".loader_inner").css({ visibility: "hidden", opacity: "0" });
      $(".popup_blocks .popup_container").addClass("opened");
    }
  });

  $(".collection5_parent .standard_button.red").click(function () {
    if (
      $(this).parents(".collections_block5").find(".collection5_items").length
    ) {
      if ($(this).parents(".collection5_parent").hasClass("active")) {
        $(this)
          .parents(".collections_block5")
          .find(".collection5_items")
          .stop()
          .animate({ height: "0", opacity: "0" }, 400);
        $(this).parents(".collection5_parent").removeClass("active");
        $(this).parents(".collections_block5").removeClass("active");
        $(this).html("VIEW WATCHES");
      } else {
        $(this)
          .parents(".collections_block5")
          .find(".collection5_items")
          .stop()
          .animate(
            {
              height: $(this)
                .parents(".collections_block5")
                .find(".collection5_items")
                .find(".collections_section")
                .height(),
              opacity: "1",
            },
            400
          );
        $(this).parents(".collection5_parent").addClass("active");
        $(this).parents(".collections_block5").addClass("active");
        $(this).html("HIDE WATCHES");
      }
    }
  });

  $("body").on("click", ".register_button", function (e) {
    e.preventDefault();
    $(".seiko_dialog").removeClass("active");
    $(".register_form_block").addClass("active");
    setPholder();
    return false;
  });

  $("body").on("click", ".login_button", function (e) {
    e.preventDefault();
    $(".seiko_dialog").removeClass("active");
    $(".login_form_block").addClass("active");
    setPholder();
    return false;
  });

  $("body").on("click", ".recovery_button", function (e) {
    e.preventDefault();
    $(".seiko_dialog").removeClass("active");
    $(".recovery_form_block").addClass("active");
    setPholder();
    return false;
  });

  $("body").on("click", ".backtosignin", function (e) {
    e.preventDefault();
    $(".seiko_dialog").removeClass("active");
    $(".login_form_block").addClass("active");
    setPholder();
    return false;
  });

  if ($.cookie("wishlist")) {
    _wished_products_handles = $.cookie("wishlist").split(",");
  }

  if ($(".product_desc_cont").length) {
    if (_wished_products_handles.length > 0) {
      var __this = $(".product_desc_cont");
      if (__this.find(".wishlist")[0]) {
        var _handl = __this.find(".wishlist").attr("data-handle").toString();
        if (_wished_products_handles.indexOf(_handl) > -1)
          __this.find(".wishlist").addClass("active");
      }
    }
  }

  if ($(".corporate_container .product_image_block").length) {
    var _cr_this = $(".corporate_container .product_block");
    setTimeout(function () {
      loadShadowImage(_cr_this);
    });
  }

  // var previousQuantity;
  // var previous_item_total;
  // $(".cart_item_quantity .increment").click(function () {
  //   // $(this).parent().find(".cart_item_quantity_input").val(+$(this).parent().find(".cart_item_quantity_input").val() + 1);

  //   var $quantityInput = $(this).parent().find(".cart_item_quantity_input");
  //   previousQuantity = parseInt($quantityInput.val());
  //   $quantityInput.val(previousQuantity + 1);

  //   console.log('$quantityInput', $quantityInput.val);

  //   var diss_subTotal = $("#diss_subTotal").text();
  //   console.log("diss_subTotal", diss_subTotal);

  //   var diss_subTotal = diss_subTotal.replace(/^\$/, "");
  //   diss_subTotal = diss_subTotal.replace(/,/g, "");

  //   let item_total = $(this).parent().find(".discount_price").attr("value");
  //   previous_item_total = item_total;

  //   if (item_total.includes("$")) {
  //     var i_total = item_total.replace("$", "");
  //     item_total = parseFloat(i_total);
  //     console.log("item_total$", item_total);
  //   } else {
  //     item_total = parseFloat(
  //       $(this).parent().find(".discount_price").attr("value")
  //     );
  //     console.log("item_total", item_total);
  //   }

  //   console.log("item_total", item_total);

  //   let prev_subTotal = parseFloat(diss_subTotal);
  //   let new_total = item_total + prev_subTotal;
  //   // $('#diss_subTotal').text(new_total);
  //   $("#diss_subTotal").text(
  //     new_total.toLocaleString("en-US", { style: "currency", currency: "USD" })
  //   );
  //   console.log("new_total", new_total);
  // });

  $(".cart_item_quantity .decrement").click(function () {
    if ($(this).parent().find(".cart_item_quantity_input").val() > 0) {
      $(this)
        .parent()
        .find(".cart_item_quantity_input")
        .val(+$(this).parent().find(".cart_item_quantity_input").val() - 1);
      var diss_subTotal = $("#diss_subTotal").text();
      console.log("diss_subTotal", diss_subTotal);

      var diss_subTotal = diss_subTotal.replace(/^\$/, "");
      diss_subTotal = diss_subTotal.replace(/,/g, "");

      let item_total = $(this).parent().find(".discount_price").attr("value");
      if (item_total.includes("$")) {
        var i_total = item_total.replace("$", "");
        item_total = parseFloat(i_total);
        console.log("item_total$", item_total);
      } else {
        item_total = parseFloat(
          $(this).parent().find(".discount_price").attr("value")
        );
        console.log("item_total", item_total);
      }

      let prev_subTotal = parseFloat(diss_subTotal);
      let new_total = prev_subTotal - item_total;
      // $('#diss_subTotal').text(new_total);
      var formatted_total = new_total.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });

      // Update the text content of the element with the formatted total
      $("#diss_subTotal").text(formatted_total);
      console.log("new_total", new_total);
    }
  });

  if ($(".collection_page_content").length) {
    $(window).scroll(function () {
      if (!_loadingcollectionproducts) {
        var scrollOffset = $(window).scrollTop();
        if ($(".collection5_videos_container").length) {
          var loadOffset =
            $(".collection5_videos_container").offset().top - 900;
        } else if ($(".shop_social.catalog").length) {
          var loadOffset = $(".shop_social.catalog").offset().top - 900;
        }

        if (scrollOffset > loadOffset) {
          NexstFilteredList();
        }
      }
    });
  }

  if ($(".search_page_content").length) {
    $(window).scroll(function () {
      if (!_loadingcollectionproducts) {
        var scrollOffset = $(window).scrollTop();
        var loadOffset = $(".footer").offset().top - 900;

        if (scrollOffset > loadOffset) {
          NexstFilteredList();
        }
      }
    });
  }

  /////////////////GEVORGS SCRIPTS STARTS///////////////////////////////////////////////////////////
  if ($(".template-index")[0] || $(".shop_social.home")[0]) {
    LoadShopSocialJSON(
      _manual_shop_social_json_url,
      0,
      function (_manual_socials) {
        if (_manual_socials.length > 0) {
          __shop_social = _manual_socials;
          ShopSocialCreate("home");
        } else {
          LoadShopSocialJSON(
            _auto_shop_social_json_url,
            0,
            function (_auto_socials) {
              __shop_social = _auto_socials;
              ShopSocialCreate("home");
            }
          );
        }
      }
    );
  }

  if ($(".template-collection")[0]) {
    CreateFilters();

    LoadShopSocialJSON(
      _manual_shop_social_json_url,
      _collection_id,
      function (_manual_socials) {
        if (_manual_socials.length > 0) {
          __shop_social = _manual_socials;
          ShopSocialCreate("catalog");
        } else {
          LoadShopSocialJSON(
            _auto_shop_social_json_url,
            _collection_id,
            function (_auto_socials) {
              __shop_social = _auto_socials;
              ShopSocialCreate("catalog");
            }
          );
        }
      }
    );
  }

  if ($(".login_container")[0]) {
    var _hashed = window.location.hash.replace("#", "").trim();
    if (_hashed == "recover") {
      $(".seiko_dialog").removeClass("active");
      $(".recovery_form_block").addClass("active");
    } else if (_hashed == "login") {
      $(".seiko_dialog").removeClass("active");
      $(".login_form_block").addClass("active");
    }
  }

  if ($("#schedule_year")[0]) {
    var _yn = new Date();
    var _ynn = _yn.getFullYear();
    $("#schedule_year").append('<option value="" selected>Year</option>');
    for (var _u = 0; _u < 3; _u++) {
      $("#schedule_year").append(
        '<option value="' + (_ynn + _u) + '" >' + (_ynn + _u) + "</option>"
      );
    }
  }

  if ($("#registartion_year")[0]) {
    var _yn = new Date();
    var _ynn = _yn.getFullYear();
    $("#registartion_year").append('<option value="" selected>Year</option>');
    for (var _u = 0; _u < 120; _u++) {
      $("#registartion_year").append(
        '<option value="' + (_ynn - _u) + '" >' + (_ynn - _u) + "</option>"
      );
    }
  }

  if ($(".search_page_content")[0]) {
    if ($(".product_item_for_filter")[0]) {
      $(".product_item_for_filter").each(function () {
        $(".product_block_group_" + $(this).attr("data-group")).append($(this));
      });
    }
    loadAllProducts();
  }

  if ($(".wishlist_content")[0]) {
    if (_wished_products_handles.length > 0) {
      LoadWishlistProduct();
    } else {
      $(".wishlist_empty").show();
    }
  }

  if ($(".manuals_form")[0]) {
    LoadManuals();
  }

  if ($("#bookmarkme").length) {
    $(".copy_link").html(window.location.href);
  }

  $("body").on("click", "#bookmarkme", function (e) {
    e.preventDefault();

    var copyLink = document.querySelector(".copy_link");
    var range = document.createRange();
    range.selectNode(copyLink);
    window.getSelection().addRange(range);

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      alert("Copy email command was " + msg);
    } catch (err) {
      alert("Oops, unable to copy");
    }

    window.getSelection().removeAllRanges();
  });

  $("body").on("click", ".sortingoption", function (e) {
    e.preventDefault();
    $(".sortingoption").removeClass("active");
    $(this).addClass("active");

    var _tags = [];
    $(".filteringoption").each(function () {
      if ($(this).hasClass("active")) _tags.push($(this).attr("data-id"));
    });

    var _url =
      window.location.origin +
      "/collections/" +
      _collection_handle +
      "/?sort_by=" +
      $(this).attr("data-id");
    if (_tags.length > 0) _url = _url + "#" + _tags.join("+");

    history.pushState({}, "", _url);

    $(".selected_filters").show();
    $(".sorting_shortcut_cont").css("display", "inline-block");
    var _typ = $(this).hasClass("sorting-p") ? "Price" : "FEATURED";
    $(".sorting_shortcut").empty();
    $(".sorting_shortcut").append(
      "<li>" +
        _typ +
        ": <span>" +
        $(this).html() +
        '<a class="remove_selected_sorting" href="#"></a></span></li>'
    );

    $(".product_block_margin").empty();
    $(".loadmore").show();
    _ajaxloadingpageid = 1;
    _productslistshow = 1;
    _loadingcollectionproducts = true;
    loadAllProducts();
    return false;
  });

  $("body").on("click", ".filteringoption", function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }
    _productslistshow = 1;
    StartFilter();
    return false;
  });

  $("body").on("click", ".remove_selected_filter", function (e) {
    e.preventDefault();
    var _tag = $(this).parent().text().trim();
    $(this).parent().remove();
    $(".filteringoption").each(function () {
      if ($(this).attr("data-id") == _tag) $(this).removeClass("active");
    });
    _productslistshow = 1;
    StartFilter();
    return false;
  });

  $("body").on("click", ".remove_selected_sorting", function (e) {
    e.preventDefault();
    $(this).parent().remove();
    $(".sortingoption").removeClass("active");
    $(_def_sorting).addClass("active");
    $(".product_block_margin").empty();
    $(".loadmore").show();
    _ajaxloadingpageid = 1;
    _productslistshow = 1;
    _loadingcollectionproducts = true;
    loadAllProducts();
    return false;
  });

  $("body").on("click", "#clear_filters", function (e) {
    e.preventDefault();
    var _url = window.location.origin + "/collections/" + _collection_handle;
    history.pushState({}, "", _url);
    $(".filteringoption").removeClass("active");

    if ($(".sortingoption.active")[0]) {
      $(".sortingoption").removeClass("active");
      $(_def_sorting).addClass("active");
      $(".product_block_margin").empty();
      $(".loadmore").show();
      _ajaxloadingpageid = 1;
      _productslistshow = 1;
      _loadingcollectionproducts = true;
      loadAllProducts();
    } else {
      _productslistshow = 1;
      StartFilter();
    }
    return false;
  });

  $("body").on("click", ".gotoschedule", function (e) {
    e.preventDefault();
    var _city = $(this).parent().find(".section_title").html();
    $("#boutique_step1")
      .stop()
      .animate({ opacity: "0" }, 500, function () {
        $(this).css("display", "none");
        $("#boutique_step2")
          .css({ display: "block", opacity: "0" })
          .stop()
          .animate({ opacity: "1" }, 500);
        $("#cityname").html(_city);
        setPholder();
      });
    return false;
  });

  $("body").on("click", ".backtoboutiques", function (e) {
    $("#boutique_step2")
      .stop()
      .animate({ opacity: "0" }, 500, function () {
        $(this).css("display", "none");
        $("#boutique_step1")
          .css({ display: "block", opacity: "0" })
          .stop()
          .animate({ opacity: "1" }, 500);
        $("#wr_thankyou").hide();
        $(".appointment_form")[0].reset();
      });
  });

  /*
   $('body').on('click', '.schedulrequestform', function(e){
		//e.preventDefault();  
     	if($('.appointment_form').length > 0){
          $.validate({
            form: '.appointment_form', 
            scrollToTopOnError: false,
            onSuccess: function(){
            	if($('#schedule_name').val().trim().length>0 && $('#schedule_email').val().trim().length>0  && $('#schedule_phone').val().trim().length>0  && $('#schedule_email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)){
                   $('.schedulrequestform').hide();
                   $('.schedulrequestform_loading').show();
                   var _data={};
                   _data["form"]= "schedule";
                   _data["city"]= $('#cityname').html();
                   _data["name"]=$('#schedule_name').val().trim();
                   _data["email"]=$('#schedule_email').val().trim();
                   _data["phone"]=$('#schedule_phone').val().trim();
                   _data["how"]=$("input[name='contact_type']:checked").val();
                   _data["whene"]=$('#schedule_month').val()=="" ? "01" : $('#schedule_month').val();
                   _data["whene"]=_data["whene"]+"."+($('#schedule_day').val()=="" ? "01" : $('#schedule_day').val());
                   _data["whene"]=_data["whene"]+"."+$('#schedule_year').val();
                     PostRec('http://seiko-b2b.herokuapp.com/postrequest',_data, function(_err, ___data){
                       	   if(!_err){
                             	$('.appointment_form')[0].reset();
                             	$(".selectpicker").val('default');
								$(".selectpicker").selectpicker("refresh");
                                $('.schedulrequestform').show();
                   				$('.schedulrequestform_loading').hide();
                             	$('#wr_thankyou').show();
                             	$('#boutique_step2').stop().animate({"opacity":"0"}, 500,function(){
                                    $(this).css('display','none');
                                    $('#boutique_step1').css({'display':'block',"opacity":"0"}).stop().animate({"opacity":"1"}, 500);
                                });
                           } else {

                           }
                     });	
              	}
            	return false;
            }
          });
        }
     	
    });
  */

  $("body").on("click", ".watchregistartionform", function (e) {
    //e.preventDefault();
    $("#wr_thankyou").hide();
    $.validate({
      form: ".watchreg_form",
      scrollToTopOnError: false,
      onSuccess: function () {
        if (
          $("#wr_collection").val() != "" &&
          $("#wr_brand").val() != "" &&
          $("#wr_model").val().trim().length > 0 &&
          $("#wr_serial").val().trim().length > 0 &&
          $("#wr_case").val().trim().length > 0 &&
          $("#wr_fname").val().trim().length > 0 &&
          $("#wr_lname").val().trim().length > 0 &&
          $("#wr_address").val().trim().length > 0 &&
          $("#wr_city").val().trim().length > 0 &&
          $("#wr_zip").val().trim().length > 0 &&
          $("#wr_phone").val().trim().length > 0 &&
          $("#wr_email")
            .val()
            .trim()
            .match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i)
        ) {
          $(".watchregistartionform").hide();
          $(".schedulrequestform_loading").show();
          var _data = {};
          _data["form"] = "watchregistration";
          _data["brand"] = $("#wr_brand").val().trim();
          _data["collection"] = $("#wr_collection").val().trim();
          _data["model"] = $("#wr_model").val().trim();
          _data["serial"] = $("#wr_serial").val().trim();
          _data["case"] = $("#wr_case").val().trim();
          _data["gender"] = $("#wr_gender").val().trim();
          _data["fname"] = $("#wr_fname").val().trim();
          _data["lname"] = $("#wr_lname").val().trim();
          _data["email"] = $("#wr_email").val().trim();
          _data["address1"] = $("#wr_address").val().trim();
          _data["address2"] = $("#wr_address2").val().trim();
          _data["city"] = $("#wr_city").val().trim();
          _data["zip"] = $("#wr_zip").val().trim();
          _data["phone"] = $("#wr_phone").val().trim();
          _data["birth"] =
            $("#wr_month").val() == "" ? "01" : $("#wr_month").val();
          _data["birth"] =
            _data["birth"] +
            "." +
            ($("#wr_day").val() == "" ? "01" : $("#wr_day").val());
          // _data["birth"]=_data["birth"]+"."+$('#registartion_year').val();
          _data["education"] = $("#wr_education").val().trim();
          _data["income"] = $("#wr_income").val().trim();
          _data["other"] = $("#wr_other").val().trim();
          _data["for"] = $("#wr_for").val().trim();
          _data["subscribe"] = $("#wr_subscribe").prop("checked")
            ? "Yes"
            : "No";

          PostRec(
            "https://seiko-b2b.herokuapp.com/postrequest",
            _data,
            function (_err, ___data) {
              if (!_err) {
                $(".watchreg_form")[0].reset();
                $(".selectpicker").val("default");
                $(".selectpicker").selectpicker("refresh");
                $(".watchregistartionform").show();
                $(".schedulrequestform_loading").hide();
                $("#wr_thankyou").show();
              } else {
              }
            }
          );
        }
        return false;
      },
    });
  });

  // $(document).ready(function() {
  //   if ($('.register_form_block').hasClass('active')) {
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.register_form_block').addClass('active'); // Show register form
  //   }
  //   else if ($('.recovery_form_block').hasClass('active')) {
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.recovery_form_block').addClass('active'); // Show recovery form
  //   }
  //   else {
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.login_form_block').addClass('active'); // Show login form
  //   }
  // });

  // $(document).ready(function() {
  // // Show the login form by default or based on condition
  //   $('.register_form_block').addClass('active');

  //   // Click events to switch between forms
  //   $('.register_button').on('click', function(e) {
  //     e.preventDefault();
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.register_form_block').addClass('active'); // Show register form
  //   });

  //   $('.recovery_button').on('click', function(e) {
  //     e.preventDefault();
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.recovery_form_block').addClass('active'); // Show recovery form
  //   });

  //   $('.login_button').on('click', function(e) {
  //     e.preventDefault();
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.login_form_block').addClass('active'); // Show login form
  //   });

  //   $('.backtosignin').on('click', function(e) {
  //     e.preventDefault();
  //     $('.seiko_dialog').removeClass('active'); // Hide all forms
  //     $('.login_form_block').addClass('active'); // Show login form
  //   });
  // });

  // $("body").on("click", ".changepasswordbutton", function (e) {
  //   e.preventDefault();

  //   $("#wr_thankyou").hide();
  //   $(".changepasswordbutton").hide();
  //   $(".schedulrequestform_loading").show();

  //   // const captchaToken = grecaptcha.getResponse();

  //   // // Check if captcha is solved
  //   // if (!captchaToken) {
  //   //   alert("Please complete the captcha verification.");
  //   //   $(".changepasswordbutton").show();
  //   //   $(".schedulrequestform_loading").hide();
  //   //   return false;
  //   // }

  //   const formData = $("#passwordrecoveryform").serialize() + "&g-recaptcha-response=" + captchaToken;

  //   $.ajax({
  //     type: $("#passwordrecoveryform").attr("method"),
  //     url: $("#passwordrecoveryform").attr("action"),
  //     data: $("#passwordrecoveryform").serialize(),
  //     success: function (data) {
  //       $("#wr_thankyou").show();
  //       //$('.changepasswordbutton').show();
  //       $(".schedulrequestform_loading").hide();
  //     },
  //     error: function (data) {
  //       console.log('changePass_error', data);
  //     },
  //   });
  //   return false;
  // });

  // $("#create_customer").submit(function (event) {
  //   // Prevent default form submission
  //   event.preventDefault();
  //   $(".register_errors")
  //     .stop()
  //     .animate({ opacity: "1" }, 50, function () {
  //       $(this).addClass("reg_loading").css("visibility", "visible");
  //     });

  //   if ($("#state").is(":checked")) {
  //     $("#state").val("Subscribed");
  //   } else {
  //     $("#state").val("unSubscribed");
  //   }

  //   // Send registration data to Laravel backend
  //   $.ajax({
  //     url: "https://shop.seiko-apps.com/nick_and_dent/public/api/postrequest/customer",
  //     type: "POST",
  //     // contentType: 'application/json',
  //     dataType: "json",
  //     data: {
  //       first_name: $("#first_name").val(),
  //       last_name: $("#last_name").val(),
  //       email: $("#email").val(),
  //       tags: $("#tags").val(),
  //       password: $("#password").val(),
  //       state: $("#state").val(),
  //     },

  //     success: function (data) {
  //       console.log("Registration successful:", data);

  //       if (data.message.email) {
  //         $(".check-msg").hide();
  //         $(".seiko_dialog").removeClass("active");
  //         $(".login_form_block").addClass("active");
  //       } else {
  //         $(".form_block .msg").text(data.message).css("color", "red").show();
  //         $(".check-msg").show();
  //       }

  //       $(".register_errors")
  //         .stop()
  //         .animate({ opacity: "0" }, 100, function () {
  //           $(this).css("visibility", "hidden");
  //         });
  //     },

  //     error: function (xhr, status, error) {
  //       console.error("Registration error:", error);
  //       console.error("Registration xhr:", xhr.responseText);

  //       var response = JSON.parse(xhr.responseText);
  //       console.error("Registration new:", response);
  //       if (response.message) {
  //         $(".form_block .msg")
  //           .text(response.message)
  //           .css("color", "red")
  //           .show();
  //       } else {
  //         $(".form_block .msg").text(response.error).css("color", "red").show();
  //       }

  //       $(".register_errors")
  //         .stop()
  //         .animate({ opacity: "0" }, 100, function () {
  //           $(this).css("visibility", "hidden");
  //         });
  //     },
  //   });
  // });

  // $("#create_customer").submit(function(e) {
  //     if($('#password').val().trim()==$('#password_confirmation').val().trim() && $('#password').val().trim().length>4 &&
  //$('#password_confirmation').val().trim().length>4 && $('#first_name').val().trim().length>0  && $('#last_name').val().trim().length>0 && $('#tags').val().trim().length>2
  //&&  $('#email').val().trim().match(/[\d\w\-\_\.]+@[\d\w\-\_\.]+\.[\w]{2,4}/i) && $("#g-recaptcha-response").val()!="")
  //{
  // $('.register_errors').stop().animate({"opacity":"1"}, 50, function(){
  //   $(this).addClass('reg_loading').css('visibility','visible');
  // });

  //      		 $.ajax({
  //                type: "POST",
  //             	 url: "http://127.0.0.1:8000/api/postrequest/customer",
  //                data:  $('#create_customer').serialize(),
  //                success: function(data) {

  // 			var res = JSON.parse(data);

  //                  if(res.error){
  //                     $('.register_errors').removeClass('reg_loading');
  //                     $('.register_errors span').hide();
  //                     $('.register_errors span.'+res.error).show();

  //                     setTimeout(function(){
  // $('.register_errors').stop().animate({"opacity":"0"}, 100,function(){
  //     $(this).css('visibility','hidden');
  // });
  //                           $('.register_errors span').hide();
  //                     }, 2000);

  //                  }
  //                  else if(res.status){
  //                       $('.login_button').trigger('click');

  //                       $('.register_errors').removeClass('reg_loading');
  //                       $('.register_errors span').hide();
  //                       $('.register_errors span.confirm').show();

  //                       setTimeout(function(){
  //                             $('.register_errors').stop().animate({"opacity":"0"}, 100,function(){
  //                                 $(this).css('visibility','hidden');
  //                             });
  //                             $('.register_errors span').hide();
  //                       }, 2000);
  //                  }

  //                },
  //           	 error: function (data) {
  //                  console.log('data1', data.responseText);

  //                  var res = JSON.parse(data.responseText);

  //                  if(res.error){
  //                     $('.register_errors').removeClass('reg_loading');
  //                     $('.register_errors span').hide();
  //                     $('.register_errors span.'+res.error).show();

  //                     setTimeout(function(){
  //                           $('.register_errors').stop().animate({"opacity":"0"}, 100,function(){
  //                               $(this).css('visibility','hidden');
  //                           });
  //                           $('.register_errors span').hide();
  //                     }, 2000);

  //                  }
  //                  else if(res.status){
  //                       $('.login_button').trigger('click');

  //                       $('.register_errors').removeClass('reg_loading');
  //                       $('.register_errors span').hide();
  //                       $('.register_errors span.confirm').show();

  //                       setTimeout(function(){
  //                             $('.register_errors').stop().animate({"opacity":"0"}, 100,function(){
  //                                 $(this).css('visibility','hidden');
  //                             });
  //                             $('.register_errors span').hide();
  //                       }, 2000);
  //                  }

  //                  console.log(res);
  //                },
  //              });
  // 		}
  //     e.preventDefault(); // avoid to execute the actual submit of the form.
  // });

  $("#account_activation_form").submit(function (e) {
    if (
      $("#password").val().trim().length < 5 ||
      $("#password_confirmation").val().trim().length < 5 ||
      $("#password").val().trim() != $("#password_confirmation").val().trim()
    ) {
      e.preventDefault();
    }
  });

  /////////////////GEVORGS SCRIPTS ENDS///////////////////////////////////////////////////////////

  //$('.social_links a').hover(function(){
  //	$(this).parent().toggleClass('active');
  //	$(this).toggleClass('active');
  //});

  if ($(".selectpicker").length > 0) {
    $(".selectpicker").selectpicker();
    $(".bootstrap-select").click(function () {
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
      } else {
        $(".bootstrap-select").removeClass("open");
        $(this).toggleClass("open");
      }
    });
  }

  if ($(".bootstrap-select").length) {
    $("body").click(function (e) {
      if (!$(e.target).parents().hasClass("bootstrap-select")) {
        $(".bootstrap-select").removeClass("open");
      }
    });
  }

  if ($(".parallax_bg").length > 0) {
    $(window).scroll(function (e) {
      if (window.innerWidth < 768) {
        if ($(".top_banner").length) {
          parallax(
            "parallax_bg",
            $(".top_banner").innerHeight() + 54,
            0.4,
            "top"
          );
        } else {
          parallax("parallax_bg", 54, 0.4, "top");
        }
      } else {
        if ($(".top_banner").length) {
          parallax(
            "parallax_bg",
            $(".top_banner").innerHeight() + 60,
            0.4,
            "top"
          );
        } else {
          parallax("parallax_bg", 60, 0.4, "top");
        }
      }

      if ($(".img_block5")[0]) {
        paralaxCollection5();
      }
    });
  }

  if ($(".story_gallery").length) {
    var $gallery = $(".story_gallery").flickity({
      pageDots: false,
      wrapAround: true,
    });

    var flickity = $gallery.data("flickity");

    var $galleryNav = $(".story_gallery_nav");
    var $galleryNavItems = $galleryNav.find("li");

    if ($(".story_gallery_nav .is_selected").length) {
      $gallery.flickity("select", $(".story_gallery_nav .is_selected").index());
    }

    $galleryNav.on("click", "li", function () {
      var index = $(this).index();
      $galleryNav.find("li").removeClass("is_selected");
      $(this).addClass("is_selected");
      $gallery.flickity("select", index);
    });

    $gallery.on("dragEnd.flickity", function (event, pointer) {
      var sel_index = $(".story_gallery_cell.is-selected").index();
      $(".story_gallery_nav").find("li").removeClass("is_selected");
      $(".story_gallery_nav").find("li").eq(sel_index).addClass("is_selected");
      $(".story_gallery_nav").scrollLeft(
        $(".story_gallery_nav").find("li").eq(sel_index).offset().left
      );
    });
  }

  if ($(".corporate_gallery").length) {
    var $corporate_gallery = $(".corporate_gallery .carousel").flickity({
      bgLazyLoad: true,
      wrapAround: true,
    });
  }

  /*	if($("input[name='card_number']").length){
		$("input[name='card_number']").inputmask();		
	}*/
  if ($("input[name='monthyear']").length) {
    var testmask = $("input[name='monthyear']");
    Inputmask("datetime", {
      inputFormat: "mm/yy",
    }).mask(testmask);
  }

  if ($(".search_form").length > 0) {
    $.validate({
      form: ".search_form",
    });
  }

  if ($(".search_form_mobile").length > 0) {
    $.validate({
      form: ".search_form_mobile",
    });
  }

  if ($(".checkout_form").length > 0) {
    $.validate({
      form: ".checkout_form",
      scrollToTopOnError: false,
    });
  }

  if ($(".checkout_login_form").length > 0) {
    $.validate({
      form: ".checkout_login_form",
      scrollToTopOnError: false,
    });
  }

  // if ($("#customer_login").length > 0) {
    // $.validate({
    //   form: "#customer_login",
    //   scrollToTopOnError: false,
    // });
  // }

  if ($(".recovery_form_block form").length > 0) {
    $.validate({
      form: ".recovery_form_block form",
      scrollToTopOnError: false,
    });
  }

  if ($(".profile_form").length > 0) {
    $.validate({
      form: ".profile_form",
      scrollToTopOnError: false,
    });
  }

  if ($(".manuals_form").length > 0) {
    $.validate({
      form: ".manuals_form",
      onSuccess: function (e) {
        //$('.manuals_form .sku').css('display', 'none');
        //$('.manuals_form .standard_button').css('display', 'block');
        SearchManuals($("#manual_search_product").val());
        return false;
      },
    });
  }

  $(".faq_col .question").click(function () {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");

      $(this).next(".answer").animate({ height: 0 }, 200);
    } else {
      $(".faq_col").removeClass("active");
      $(this).parent().addClass("active");
      $(".answer").animate({ height: 0 }, 200);
      $(this)
        .next(".answer")
        .animate(
          { height: $(this).next(".answer").find("span").height() + 20 },
          200
        );
    }
  });

  $(window).on("hashchange", function () {
    hashchangeSupport();
  });

  if (window.location.hash && $(".support_tab").length) {
    hashchangeSupport();
  }

  if (window.location.hash && $(".search_tab").length) {
    hashchangeSearch();
  }

  $(".search_tab").click(function () {
    if ($(window).scrollTop() < 2) {
      $(window).scrollTop($(window).scrollTop() + 1);
    }
    $(".search_tab").removeClass("active");
    if ($(this).parent().hasClass("search_tabs")) {
      $(this).addClass("active");
    } else {
      $(".support_tab[data-tab=seiko]").addClass("active");
    }
    $(".search_tab_content").removeClass("active");
    var indexTab = $(this).data("tab");
    $(".search_tab_content." + indexTab).addClass("active");
    history.pushState({}, "", "#" + indexTab);
  });

  $(".support_tab").click(function () {
    $(".support_tab").removeClass("active");
    if ($(this).parent().hasClass("support_tabs")) {
      $(this).addClass("active");
    } else {
      $(".support_tab[data-tab=service]").addClass("active");
    }
    $(".support_tab_block").removeClass("active");
    var indexTab = $(this).data("tab");
    $(".support_tab_block." + indexTab).addClass("active");
    contentHeight();
    history.pushState({}, "", "#" + indexTab);

    $(".manuals_form")[0].reset();
    $(".download_manual").css("display", "none");
    $(".no_manual_found").css("display", "none");
  });

  $("body").on("click", ".pholder", function () {
    $(this).parent().find("input").trigger("focus");
  });
  $(".form_block input").each(function () {
    if ($(this).val() != "") {
      $(this).parent().addClass("active");
    } else {
      $(this).parent().removeClass("active");
    }
  });
  $(".form_block input, .promo_form_block input").blur(function () {
    if ($(this).val() != "") {
      $(this).parent().addClass("active");
    } else {
      $(this).parent().removeClass("active");
    }
  });

  $(".checkbox_button").click(function () {
    if (!$(this).hasClass("checked")) {
      $(this).addClass("checked");

      if ($(this).hasClass("shipping_same")) {
        if ($(".checkout_billing_address").length > 0) {
          $(".checkout_billing_address").removeClass("opened");
        }
      }
    } else {
      $(this).removeClass("checked");

      if ($(this).hasClass("shipping_same")) {
        if ($(".checkout_billing_address").length > 0) {
          $(".checkout_billing_address").addClass("opened");
        }
      }
    }
  });

  $(".radio_button").click(function () {
    $(".radio_button").removeClass("checked");
    if (!$(this).hasClass("checked")) {
      $(this).addClass("checked");
    } else {
      $(this).removeClass("checked");
    }
  });

  /*$('.checkout_tab.login').click(function(){
		$('.checkout_tab').removeClass('active');
		$(this).addClass('active');
		$('.checkout_login_form').addClass('opened');
	});
	
	$('.checkout_tab.guest').click(function(){
		$('.checkout_tab').removeClass('active');
		$(this).addClass('active');
		$('.checkout_login_form').removeClass('opened');
	});*/

  $(".show_more a").click(function () {
    if (!$(this).parent().hasClass("opened")) {
      $(this).parent().addClass("opened");
      $(".product_description")
        .find(".more_text")
        .addClass("opened")
        .css(
          "max-height",
          $(".product_description")
            .find(".more_text .inner_text")
            .innerHeight() + 50
        );
    } else {
      $(this).parent().removeClass("opened");
      $(".product_description")
        .find(".more_text")
        .removeClass("opened")
        .css("max-height", show_more_height);
    }
    $(".show_more a").show();
    $(this).hide();
  });

  if ($(".product_zoom_block").length > 0) {
    if (!device.mobile()) {
      $(".tile")
        .on("mouseover", function () {
          $(this)
            .children(".zoom_block")
            .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
        })
        .on("mouseout", function () {
          $(this).children(".zoom_block").css({ transform: "scale(1)" });
        })
        .on("mousemove", function (e) {
          $(this)
            .children(".zoom_block")
            .css({
              "transform-origin":
                ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
                "% " +
                ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
                "%",
            });
        });
    }
  }

  if ($(".homepage_content").length) {
    loadAllBGImages($(".home_preloadimage"), function () {
      setTimeout(function () {
        $(".loader_start").css({ visibility: "hidden", opacity: "0" });
        $(".home_fold_block").addClass("show");
      }, 100);
    });
  } else {
    if ($(".catalog_preloadimage").length) {
      loadAllBGImages($(".catalog_preloadimage"), function () {
        setTimeout(function () {
          $(".loader_start").css({ visibility: "hidden", opacity: "0" });
        }, 100);
      });
    } else {
      setTimeout(function () {
        $(".loader_start").css({ visibility: "hidden", opacity: "0" });
        //$('.header_top').css({"top": "0"});
      }, 100);
    }
  }

  function closeAllMenues(evt) {
    $(".login_basket").removeClass("opened");
    $(".login_block").removeClass("opened");
    $(".login_button").removeClass("opened");
    if ($(".search_open_button").hasClass("opened")) {
      $(".search_open_button").removeClass("opened");
      $(".search_form").removeClass("opened");
      $(".search_form input").val("");
    }
  }

  $("body").click(closeAllMenues);

  $(".search_open_button").on("click", function (evt) {
    closeAllMenues(evt);
    evt.stopPropagation();
    $(this).addClass("opened");
    $(".search_form").addClass("opened");
  });

  $(".search_form").on("click", function (evt) {
    evt.stopPropagation();
  });

  $(".login_button").hover(
    function () {
      $(".login_block").addClass("opened");
      $(".login_basket").addClass("opened");
      $(this).addClass("opened");
    },
    function () {
      $(".login_block").removeClass("opened");
      $(".login_basket").removeClass("opened");
      $(this).removeClass("opened");
    }
  );

  $(".actions_list").click(function (evt) {
    evt.stopPropagation();
  });

  $("body").on("click", ".social_link", function (e) {
    e.preventDefault();
    var index = $(this).data("index");
    var img = __shop_social[index]["image"];
    var product = __shop_social[index];

    if ($(".product_block_social").length > 1)
      _shop_social_corusel.flickity("destroy");

    $(".products_list").empty();

    __shop_social.map(function (_j, _o) {
      if (_j["image"] == img) {
        var _np = _j["price"].split(".");
        if (parseInt(_np[1]) > 0) {
          _np[0] = _j["price"];
        }

        var _z = _j["pimage"];
        var _neimg = _z.split(".");
        _neimg[_neimg.length - 2] = _neimg[_neimg.length - 2] + "_350x600";
        var _img = _neimg.join(".");

        $(".products_list").append(
          '<div class="product_block_social carousel-cell" id="p_' +
            _o +
            '"><div class="product_block">' +
            ($(".products_list").data("wishlist") == "yes"
              ? '<div data-handle="' +
                _j["handle"] +
                '" class="wishlist"></div>'
              : "") +
            '<a href="/products/' +
            _j["handle"] +
            '" class="product_url" >' +
            '<div class="product_image_block popup_product_image_block shadow_load" ><img src="' +
            $(".products_list").data("spin") +
            '" alt="' +
            _j["title"] +
            '" title="' +
            _j["title"] +
            '" class="spinner" data-src="' +
            _img +
            '" /></div>' +
            '<span class="product_name_price">' +
            '<span class="product_price popup_product_price">$' +
            _np[0] +
            "</span>" +
            "</span>" +
            "</a>" +
            '<a href="/cart" class="standard_button white social_add_to_cart" data-id="' +
            _j["vid"] +
            '"><span class="addto">ADD TO CART</span><span class="added">ADDED</span></a>' +
            "</div></div>"
        );
      }
    });

    if ($(".product_block_social").length > 1) {
      _shop_social_corusel = $(".products_list").flickity({
        bgLazyLoad: true,
        wrapAround: true,
        autoPlay: true,
        pauseAutoPlayOnHover: true,
      });
    }

    $(".popup_image_block").html('<img src="' + img + '" alt="" title="" />');

    // $('.popup_product_image_block').html('<img src="'+$('.popup_product_image_block').attr('data-spin')+'" alt="" title="" class="spinner" />');
    load_all_social_product_images();

    //$('.popup_product_name').html(product['title']);
    //	var _np=product['price'].split('.');
    //  if(parseInt(_np[1])>0){
    //		_np[0]=product['price'];
    //  }

    //$('.popup_product_price').html('$'+_np[0]);

    //$('.popup_info_block').find('.wishlist').attr('data-handle',product['handle']);

    $(".info_popup").addClass("opened");
    $("body").addClass("y_hidden");
    $(".loader_inner").css({ visibility: "visible", opacity: "1" });
    //$('.social_add_to_cart').attr('data-id',product['vid']);
    //$('.social_add_to_cart').show();
    //$('.popup_info_block .product_url').attr('href', '/products/'+product['handle']);

    $(window)
      .resize(function () {
        if (window.innerWidth < 768) {
          var popup_other_width =
            $(".popup_image_block").width() -
            $(".popup_info_block .product_image_block").width();
          $(".popup_info_block .product_name_price").css(
            "left",
            $(".popup_info_block .product_image_block").width() +
              ((popup_other_width -
                $(".popup_info_block .product_name_price").width()) /
                2 +
                10)
          );
          $(".popup_info_block .standard_button").css(
            "left",
            $(".popup_info_block .product_image_block").width() +
              ((popup_other_width -
                $(".popup_info_block .standard_button").width()) /
                2 -
                10)
          );
        }
      })
      .trigger("resize");

    setTimeout(function () {
      $(".loader_inner").css({ visibility: "hidden", opacity: "0" });
      $(".popup_container").addClass("opened");
    }, 100);
  });

  $(".increment, .decrement").click(function () {
    if (
      parseInt($(this).parent().find(".cart_item_quantity_input").val()) > 0
    ) {
      // $.post("/cart/change.js", {
      // quantity: parseInt($(this).parent().find(".cart_item_quantity_input").val()),
      // id: $(this).parent().find(".cart_item_quantity_input").attr("data-id"),
      // });

      var incDecValue = $(this).attr("data-inc-dec");
      var dataSku = $(this).attr("data-sku");

      var inputVal = $(this).parent().find(".cart_item_quantity_input");
      var self_element = $(this).parent().find(".cart_item_quantity_input");
      console.log("inc-dec value:", incDecValue);

      var overlay = document.getElementById("overlay");

      if (incDecValue == "incrementt") {
        overlay.style.display = "flex";
        var new_qty =
          parseInt($(this).parent().find(".cart_item_quantity_input").val()) +
          1;

        $.ajax({
          url: "/cart/change.js",
          type: "POST",
          dataType: "json",
          data: {
            quantity: new_qty,
            id: $(this)
              .parent()
              .find(".cart_item_quantity_input")
              .attr("data-id"),
          },

          success: function (data) {
            console.log("data", data);
            $("#error-message")
              .text(
                "You added items in cart are greater than number of items in inventory."
              )
              .hide();

            //---------------------------------------------------------//
            //-------------------- subtotal prices --------------------//
            //---------------------------------------------------------//
            inputVal.val(new_qty);
            var diss_subTotal = $("#diss_subTotal").text();
            console.log("diss_subTotal", diss_subTotal);

            var diss_subTotal = diss_subTotal.replace(/^\$/, "");
            diss_subTotal = diss_subTotal.replace(/,/g, "");

            let item_total = self_element
              .parent()
              .find(".discount_price")
              .attr("value");

            if (item_total.includes("$")) {
              var i_total = item_total.replace("$", "");
              item_total = parseFloat(i_total);
              console.log("item_total$", item_total);
            } else {
              item_total = parseFloat(
                self_element.parent().find(".discount_price").attr("value")
              );
              console.log("item_total", item_total);
            }

            console.log("item_total", item_total);

            let prev_subTotal = parseFloat(diss_subTotal);
            let new_total = item_total + prev_subTotal;
            // $('#diss_subTotal').text(new_total);
            $("#diss_subTotal").text(
              new_total.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })
            );
            console.log("new_total", new_total);

            //---------------------------------------------------------//
            //---------------------  items prices ---------------------//
            //---------------------------------------------------------//
            var single_item_original_price_text = self_element
              .closest(".shopping_cart_cols")
              .find(".original_real_price")
              .attr("value");
            if (single_item_original_price_text) {
              var number =
                single_item_original_price_text.match(/\d+(,\d+)?(\.\d+)?/g);
              if (number) {
                var single_item_original_price = parseFloat(
                  number[0].replace(",", "")
                );
              }
            }
            console.log(
              "single_item_original_price",
              single_item_original_price
            );

            self_element
              .parents(".shopping_cart_cols")
              .find(".discount")
              .html(
                "$" +
                  PriceFormatting(
                    (
                      parseInt(
                        self_element
                          .parent()
                          .find(".cart_item_quantity_input")
                          .val()
                      ) * parseFloat(single_item_original_price)
                    ).toFixed(2)
                  )
              );

            var single_item_price_text = self_element
              .closest(".shopping_cart_cols")
              .find(".item_real_price")
              .attr("value");
            if (single_item_price_text) {
              var number = single_item_price_text.match(/\d+(,\d+)?(\.\d+)?/g);
              if (number) {
                var single_item_price = parseFloat(number[0].replace(",", ""));
              }
            }
            console.log("single_item_price_text", single_item_price_text);
            self_element
              .parents(".shopping_cart_cols")
              .find(".line_total")
              .html(
                "$" +
                  PriceFormatting(
                    (
                      parseInt(
                        self_element
                          .parent()
                          .find(".cart_item_quantity_input")
                          .val()
                      ) * parseFloat(single_item_price)
                    ).toFixed(2)
                  )
              );

            var _subtt = 0;
            $(".line_total").each(function () {
              _subtt += parseFloat(
                self_element
                  .html()
                  .substr(1)
                  .replace(",", "")
                  .replace("<sup>", "")
                  .replace("</sup>", "")
              );
            });
            $(".subtotal_price").html("$" + PriceFormatting(_subtt));
            overlay.style.display = "none";
          },
          error: function (xhr, status, error) {
            function updateErrorMessage() {
              if (window.innerWidth < 768) {
                $("#error-message")
                  .text(
                    "Sorry, we currently have limited units of (" +
                      dataSku +
                      ") in stock. Please adjust your quantity accordingly."
                  )
                  .css("display", "block")
                  .show();
              } else if (window.innerWidth < 480) {
                $("#error-message")
                  .text(
                    "Sorry, we currently have limited units of (" +
                      dataSku +
                      ") in stock. Please adjust your quantity accordingly."
                  )
                  .css("display", "block")
                  .show();
              } else {
                $("#error-message")
                  .text(
                    "Sorry, we currently have limited units of (" +
                      dataSku +
                      ") in stock. Please adjust your quantity accordingly."
                  )
                  .css("display", "inline")
                  .show();
              }
            }

            // Initial check when the AJAX call succeeds
            updateErrorMessage();

            // Check on window resize
            $(window).resize(function () {
              updateErrorMessage();
            });

            overlay.style.display = "none";

            console.error("Error fetching product data:", error);
            console.error("Status Code:", xhr.status);
            return false;
          },
        });
      } else {
        $.post("/cart/change.js", {
          quantity: parseInt(
            $(this).parent().find(".cart_item_quantity_input").val()
          ),
          id: $(this)
            .parent()
            .find(".cart_item_quantity_input")
            .attr("data-id"),
        });

        //---------------------------------------------------------//
        //---------------------  items prices ---------------------//
        //---------------------------------------------------------//

        var single_item_original_price_text = self_element
          .closest(".shopping_cart_cols")
          .find(".original_real_price")
          .attr("value");
        if (single_item_original_price_text) {
          var number =
            single_item_original_price_text.match(/\d+(,\d+)?(\.\d+)?/g);
          if (number) {
            var single_item_original_price = parseFloat(
              number[0].replace(",", "")
            );
          }
        }

        console.log("single_item_original_price", single_item_original_price);
        self_element
          .parents(".shopping_cart_cols")
          .find(".discount")
          .html(
            "$" +
              PriceFormatting(
                (
                  parseInt(
                    self_element
                      .parent()
                      .find(".cart_item_quantity_input")
                      .val()
                  ) * parseFloat(single_item_original_price)
                ).toFixed(2)
              )
          );

        var single_item_price_text = self_element
          .closest(".shopping_cart_cols")
          .find(".item_real_price")
          .attr("value");
        if (single_item_price_text) {
          var number = single_item_price_text.match(/\d+(,\d+)?(\.\d+)?/g);
          if (number) {
            var single_item_price = parseFloat(number[0].replace(",", ""));
          }
        }
        console.log("single_item_price_text", single_item_price_text);

        self_element
          .parents(".shopping_cart_cols")
          .find(".line_total")
          .html(
            "$" +
              PriceFormatting(
                (
                  parseInt(
                    self_element
                      .parent()
                      .find(".cart_item_quantity_input")
                      .val()
                  ) * parseFloat(single_item_price)
                ).toFixed(2)
              )
          );
        var _subtt = 0;
        $(".line_total").each(function () {
          _subtt += parseFloat(
            self_element
              .html()
              .substr(1)
              .replace(",", "")
              .replace("<sup>", "")
              .replace("</sup>", "")
          );
        });
        $(".subtotal_price").html("$" + PriceFormatting(_subtt));
      }
      // var _spText = $(this).closest('.shopping_cart_cols').find('.line_total').text();
    } else if (
      parseInt($(this).parent().find(".cart_item_quantity_input").val()) == 0
    ) {
      var _url = $(this)
        .parents(".cart_item")
        .find(".cart_item_remove_url")
        .attr("href");
      window.location.href = _url;
    }
  });

  $(".cart_item_quantity_input").change(function () {
    if (parseInt($(this).val()) > 0) {
      console.log("$(this).val()", $(this).val());
      console.log("$(this).attr(data-id)", $(this).attr("data-id"));

      $.post("/cart/change.js", {
        quantity: $(this).val(),
        id: $(this).attr("data-id"),
      });

      var _sp = $(this)
        .parents(".shopping_cart_cols")
        .find(".line_price")
        .html()
        .substr(1)
        .replace(",", "")
        .replace("<sup>", "")
        .replace("</sup>", "");
      console.log("_sp", _sp);

      $(this)
        .parents(".shopping_cart_cols")
        .find(".line_total")
        .html(
          "$" +
            PriceFormatting(
              (parseInt($(this).val()) * parseFloat(_sp)).toFixed(2)
            )
        );
      var _subtt = 0;

      $(".line_total").each(function () {
        _subtt += parseFloat(
          $(this)
            .html()
            .substr(1)
            .replace(",", "")
            .replace("<sup>", "")
            .replace("</sup>", "")
        );
      });
      $(".subtotal_price").html("$" + PriceFormatting(_subtt));
    } else if (parseInt($(this).val()) == 0) {
      var _url = $(this)
        .parents(".cart_item")
        .find(".cart_item_remove_url")
        .attr("href");
      window.location.href = _url;
    }
  });

  $("body").on("click", ".social_add_to_cart", function (e) {
    e.preventDefault();
    $.post("/cart/add.js", { quantity: 1, id: $(this).attr("data-id") });
    // $(this).hide();
    var __this = $(this);

    $(this)
      .find(".addto")
      .animate({ top: "-50px" }, 100, function () {
        __this
          .prop("disabled", true)
          .css({ "pointer-events": "none" })
          .addClass("added_active");
        __this.find(".added").fadeIn("slow");
      });

    var _count =
      $("#items_in_cart_count").html() != ""
        ? parseInt($("#items_in_cart_count").html()) + 1
        : 1;
    if (_count > 0) {
      $(".icon-bag").addClass("active");
    }
    $("#items_in_cart_count").html(_count);
    $(".cart_bubble").addClass("active");
    setTimeout(function () {
      $(".cart_bubble").removeClass("active");
    }, 600);
    return false;
  });

  $("body").on("click", ".productinfo_add_to_cart", function (e) {
    e.preventDefault();

    var productId = $(this).attr("data-id");
    var discountedPrice = $(this).attr("data-discount"); // Get the discounted price from the data attribute
    var customer_id = $(this).attr("data-customer");
    var product_tag = $(this).attr("product-tag");

    var customProperties = {
      dis_price: discountedPrice,
      customer_id: customer_id,
      product_tag: product_tag,
    };

    console.log("customProperties", customProperties);

    $.post("/cart/add.js", {
      quantity: 1,
      id: productId,
      properties: customProperties,
    }); // Include the discounted price in the properties

    // $.post('/cart/add.js', {quantity: 1, id: $(this).attr('data-id'),line_price:50000,original_line_price: 25000,total_discount:-25000 ,discounts: {
    // price: 25000
    // }});

    var __this = $(this);
    if (!$(this).hasClass("product_inner_btn")) {
      $(this)
        .find(".addto")
        .animate({ top: "-50px" }, 100, function () {
          __this
            .prop("disabled", true)
            .css({ "pointer-events": "none" })
            .addClass("added_active");
          __this.find(".added").fadeIn("slow");
        });
    }

    var _count =
      $("#items_in_cart_count").html() != ""
        ? parseInt($("#items_in_cart_count").html()) + 1
        : 1;
    if (_count > 0) {
      $(".icon-bag").addClass("active");
    }
    $("#items_in_cart_count, .cart_bubble").html(_count);

    $(".cart_bubble").addClass("active");
    setTimeout(function () {
      $(".cart_bubble").removeClass("active");
    }, 600);

    return false;
  });

  $("body").on("click", ".wishlist_remove_item", function (e) {
    e.preventDefault();
    var _handle = $(this).attr("data-handle");
    var _id = $(this).attr("data-id");
    var _ind = _wished_products_handles.indexOf(_handle);
    if (_ind > -1) {
      _wished_products_handles.splice(_ind, 1);
      $.cookie("wishlist", _wished_products_handles.join(","), { path: "/" });
    }
    $("#" + _id).remove();

    if (!$(".cart_item")[0]) {
      $(".wishlist_content").hide();
      $(".wishlist_empty").show();
    }

    return false;
  });

  // $("body").on("click", ".wishlist_add_to_cart", function (e) {
  //   e.preventDefault();
  //   $.post("/cart/add.js", { quantity: 1, id: $(this).attr("data-id") });
  //   var _count =
  //     $("#items_in_cart_count").html() != ""
  //       ? parseInt($("#items_in_cart_count").html()) + 1
  //       : 1;
  //   if (_count > 0) {
  //     $(".icon-bag").addClass("active");
  //   }
  //   $("#items_in_cart_count, .cart_bubble").html(_count);
  //   $(".cart_bubble").addClass("active");
  //   setTimeout(function () {
  //     $(".cart_bubble").removeClass("active");
  //   }, 600);

  //   var _handle = $(this).attr("data-handle");
  //   var _ind = _wished_products_handles.indexOf(_handle);
  //   if (_ind > -1) {
  //     _wished_products_handles.splice(_ind, 1);
  //     $.cookie("wishlist", _wished_products_handles.join(","), { path: "/" });
  //   }
  //   $("#" + $(this).attr("data-id")).remove();

  //   if (!$(".cart_item")[0]) {
  //     $(".wishlist_content").hide();
  //     $(".wishlist_empty").show();
  //   }

  //   return false;
  // });

  $("body").on("click", ".wishlist_add_all", function (e) {
    e.preventDefault();
    $(".cart_item").each(function () {
      $.post("/cart/add.js", { quantity: 1, id: $(this).attr("id") });
      var _count =
        $("#items_in_cart_count").html() != ""
          ? parseInt($("#items_in_cart_count").html()) + 1
          : 1;
      $("#items_in_cart_count, .cart_bubble").html(_count);
      $(".cart_bubble").addClass("active");
      setTimeout(function () {
        $(".cart_bubble").removeClass("active");
      }, 600);
      // $(this).remove();
    });
    //if(_count>0){
    //	$('.icon-bag').addClass('active');
    // }
    _wished_products_handles = [];
    $.cookie("wishlist", "", { path: "/" });

    $(".wishlist_content").hide();
    $(".wishlist_empty").show();

    return false;
  });

  $(".product_block").mouseleave(function (e) {
    if (!$(e.target).hasClass("wishlist")) {
      $(this).removeClass("hover");
    }
  });

  $("body").on("click", ".wishlist", function (e) {
    e.preventDefault();
    $(this).parent().addClass("hover");
    if (!$(this).hasClass("active")) {
      if (_wished_products_handles.indexOf(_handle) == -1) {
        var _handle = $(this).attr("data-handle");
        _wished_products_handles.push(_handle);
        $.cookie("wishlist", _wished_products_handles.join(","), { path: "/" });
      }
      $(this).addClass("active");

      var bubblethis = $(this);
      bubblethis.addClass("bubble");
      setTimeout(function () {
        bubblethis.removeClass("bubble");
      }, 600);
    } else {
      var _handle = $(this).attr("data-handle");
      var _ind = _wished_products_handles.indexOf(_handle);
      if (_ind > -1) {
        _wished_products_handles.splice(_ind, 1);
        $.cookie("wishlist", _wished_products_handles.join(","), { path: "/" });
      }
      $(this).removeClass("active");

      var bubblethis = $(this);
      bubblethis.addClass("bubble");
      setTimeout(function () {
        bubblethis.removeClass("bubble");
      }, 600);
    }

    return false;
  });

  $("body").on(
    "mouseenter mouseleave",
    ".shop_social .social_link",
    function (e) {
      $(".shop_social .social_link")
        .not(this)
        .stop(true)
        .fadeTo("fast", e.type === "mouseenter" ? 0.5 : 1);
    }
  );

  $(".popup_close, .popup_close_span, .discount_info_popup_over").click(
    function (e) {
      e.preventDefault();
      if (
        !$(this).hasClass("discount_close") &&
        !$(this).hasClass("discount_info_popup_over")
      ) {
        $(this).parents(".popup_container").removeClass("opened");
        $(this).parents(".info_popup").removeClass("opened");
        $(this)
          .parents(".popup_container")
          .find(".product_image_block")
          .css("background-size", "0 0");
        $("body").removeClass("y_hidden");
        if ($(".info_popup_inner iframe").length) {
          $(".info_popup_inner iframe")[0].contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
          );
        }
      } else {
        $(".discount_info_popup").removeClass("opened");
      }
    }
  );

  $(".info_popup").click(function (e) {
    if ($(e.target).is(".cell_middle")) {
      $(".popup_close").trigger("click");
    }
  });

  $(".product_thumb").click(function () {
    if ($(this).data("image")) {
      $(".product_thumb").removeClass("active");
      $(this).addClass("active");
      if ($(".product_thumb.active").is(":first-child")) {
        $(".zoom_shadow").show();
      } else {
        $(".zoom_shadow").hide();
      }

      $(".photo_zoom").html(
        '<img src="' +
          $(".photo_zoom").attr("data-spin") +
          '" alt="" title="" class="spinner" />'
      );
      $(document).find(".photo_zoom").css("background-image", "none");

      var img = new Image();
      img.src = $(this).data("image");

      img.onload = function () {
        $(".photo_zoom").html("");
        $(document)
          .find(".photo_zoom")
          .css("background-image", "url(" + img.src + ")");
      };
    }
  });

  if ($(".photo_zoom").length) {
    $(".photo_zoom").html(
      '<img src="' +
        $(".photo_zoom").attr("data-spin") +
        '" alt="" title="" class="spinner" />'
    );

    var img = new Image();
    img.src = $(".photo_zoom").attr("data-src");

    img.onload = function () {
      $(".photo_zoom").addClass("loaded");
      $(".photo_zoom").css("background-image", "url(" + img.src + ")");
      $(".photo_zoom").html("");
      $(".photo_zoom").next(".zoom_shadow").css("background-size", "contain");
    };
  }

  $(".product_t").click(function (e) {
    e.preventDefault();

    if ($(this).find(".product_thumb.video").data("video")) {
      $(".info_popup_inner").html(
        '<iframe src="https://www.youtube.com/embed/' +
          $(this).find(".product_thumb.video").data("video") +
          '?enablejsapi=1&rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
      );
    } else {
      $(".info_popup_inner").html(
        '<img src="' + $(this).data("image") + '" alt="" title="" />'
      );
    }

    $(".product_media .popup_blocks .info_popup_inner iframe").height(
      $(".product_media .popup_blocks .info_popup_inner").innerHeight()
    );

    $(document)
      .find(".product_media .info_popup_inner")
      .find("img")
      .css("max-height", window.innerHeight - 150);

    $(".info_popup").addClass("opened");
    $("body").addClass("y_hidden");
    $(".loader_inner").css({ visibility: "hidden", opacity: "0" });
    $(".popup_container").addClass("opened");
  });

  $(".filter_sort_block span").click(function () {
    if ($(this).hasClass("opened")) {
      $(".collections_filter").removeClass("opened");
      $(".collections_filter")
        .parent()
        .find(".selected_filters")
        .removeClass("opened");
      $(".filter_sort_block span").removeClass("opened");
      $(this).removeClass("opened");
      $(".filter_dropdown").removeClass("opened");
      $(".filter_dropdown .tab_content").removeClass("active");
      $(".filter_dropdown").height(0);
    } else {
      $(".collections_filter").addClass("opened");
      $(".collections_filter")
        .parent()
        .find(".selected_filters")
        .addClass("opened");
      $(".filter_sort_block span").removeClass("opened");
      $(".filter_dropdown .tab_content").removeClass("active");
      $(this).addClass("opened");
      $(".filter_dropdown").addClass("opened");
      $(".filter_dropdown .tab_content." + $(this).data("type")).addClass(
        "active"
      );
      var block_height = $(
        ".filter_dropdown .tab_content." + $(this).data("type") + " ul"
      ).height();
      $(".filter_dropdown").height(block_height + 65);
    }
    block_height_resp = $(".tab_content.active ul").height();
  });

  $(".filter_close").click(function (e) {
    e.preventDefault();
    $(".collections_filter").removeClass("opened");
    $(".collections_filter")
      .parent()
      .find(".selected_filters")
      .removeClass("opened");
    $(".filter_sort_block span").removeClass("opened");
    $(".filter_dropdown").removeClass("opened");
    $(".filter_dropdown .tab_content").removeClass("active");
    $(".filter_dropdown").height(0);
  });

  if ($("#video_5").length) {
    var myPlayer = videojs(
      "video_5",
      { controls: true, autoplay: true, muted: true },
      function () {
        var player = this;
        player
          .on("ended", function () {
            this.play();
          })
          .on("seeking", function (e) {})
          .on("play", function (e) {})
          .on("pause", function (e) {});
      }
    );
  }

  if ($("#video_1").length) {
    var myPlayer = videojs(
      "video_1",
      { controls: true, autoplay: true, muted: true, preload: "auto" },
      function () {
        var player = this;
        player
          .on("ended", function () {
            this.play();
          })
          .on("seeking", function (e) {})
          .on("play", function (e) {})
          .on("pause", function (e) {});
      }
    );
  }

  $(window)
    .resize(function () {
      if ($(".img_block5").length) {
        $(".img_block5").each(function () {
          $(this)
            .find("img")
            .height($(this).find("div").innerHeight() + 20);
        });
      }

      if ($(".seiko_dialog").length && window.innerWidth < 640) {
        if ($(".register_form_block").length) {
          $(".dialog_container").height(
            $(".register_form_block").innerHeight()
          );
        } else {
          $(".dialog_container").height($(".login_form_block").innerHeight());
        }
      }

      if ($(".fixed_totals").length && window.innerWidth > 768) {
        $(window).scroll(function () {
          var scrollOffset = $(window).scrollTop();
          var loadOffset = $(".cart_items_table").offset().top;

          var absoluteFixed =
            $(".shopping_cart_form").innerHeight() -
            $(".shopping_cart_form").offset().top -
            $(".fixed_totals").innerHeight();
          if (scrollOffset >= absoluteFixed + 140) {
            $(".fixed_totals").css({
              position: "absolute",
              top: absoluteFixed + 90,
            });
          } else {
            $(".fixed_totals").removeAttr("style");
          }

          if (scrollOffset >= loadOffset - 50) {
            $(".fixed_totals").addClass("fixed");
          } else {
            $(".fixed_totals").removeClass("fixed");
          }

          /*if(scrollOffset > loadOffset){
					NexstFilteredList();
				}*/
        });
      }

      if ($(".top_banner").length && $(".parallax_bg").length) {
        if (window.innerWidth < 768) {
          $(".parallax_bg").css("top", $(".top_banner").innerHeight() + 54);
        } else {
          $(".parallax_bg").css("top", $(".top_banner").innerHeight() + 60);
        }
      }

      if ($(".vjs-tech").length) {
        if (window.innerWidth < 480) {
          $(".vjs-tech").attr("playsinline", "true");
        } else {
          $(".vjs-tech").removeAttr("playsinline");
        }
      }

      /*if($('.corporate_container .half_col').length){
			equalheight($('.corporate_container .half_col'));
		}
		if($('.support_tab_block.service .third_col').length){
			equalheight($('.support_tab_block.service .flexbox .third_col'));
		}*/

      if (
        $(".content").length &&
        !$(".login_container").length &&
        $(".support_block").length
      ) {
        contentHeight();
      }

      if (window.innerWidth > 640 && window.innerHeight > 800) {
        if ($(".shopify-challenge__container").length) {
          $(".shopify-challenge__container").css(
            "height",
            window.innerHeight -
              $(".header").innerHeight() -
              $(".footer").innerHeight()
          );
        }
      }

      if (window.innerWidth - $(".main_menu_inner").width() < 200) {
        $(".header .close_menu_button").css(
          "width",
          window.innerWidth - $(".main_menu_inner").width()
        );
      }

      $(".faq_col.active")
        .find(".answer")
        .animate(
          {
            height:
              $(".faq_col.active").find(".answer").find("span").height() + 20,
          },
          50
        );

      $(".product_media .popup_blocks .info_popup_inner iframe").height(
        $(".product_media .popup_blocks .info_popup_inner").innerHeight()
      );

      var fold_height_content =
        window.innerHeight -
        $(".header_top").height() -
        $(".top_banner").height();
      $(".login_container").height(fold_height_content);
      $(".error_container").height(fold_height_content);
      // $(".search_page_content").css(
      //   "min-height",
      //   fold_height_content - $("footer").height() - 20
      // );

      setPholder();

      if (window.innerWidth < 920) {
        $(".has_submenu .submenu_button")
          .unbind("click")
          .click(function (e) {
            e.preventDefault();
            if ($(this).parent().hasClass("opened")) {
              $(this).parent().removeClass("opened");
              $(this).parent().find(".submenu_list").css("max-height", 0);
            } else {
              $(".has_submenu").removeClass("opened");
              $(".has_submenu").find(".submenu_list").css("max-height", 0);
              $(this).parent().addClass("opened");
              var li_height = "";
              $(this)
                .parent()
                .find(".submenu_list li")
                .each(function () {
                  li_height = (parseInt(li_height) || 0) + $(this).height();
                });
              $(this)
                .parent()
                .find(".submenu_list")
                .css("max-height", li_height);
            }
          });
      }

      if ($(".parallax_bg").length) {
        $(".parallax_bg")
          .height($(".catalog_top_image").innerHeight())
          .width($(".collection_page_content").innerWidth());
      }

      $(".catalog_top_image")
        .find("iframe")
        .height($(".catalog_top_image").innerHeight());
      //$('.video-js .vjs-tech').css('margin-top', -(($('.video_viewport').innerHeight())/2)+'px');
      $(".vjs-loading-spinner").css(
        "top",
        $(".video_viewport").innerHeight() / 2 + "px"
      );
      $(".vjs-control-bar").css(
        "top",
        $(".video_viewport").innerHeight() - 70 + "px"
      );

      if (window.innerWidth > 768) {
        $(".story_text").height($(".story_image").innerHeight());
      }
      var timelineWidth =
        $(".story_gallery_nav li").innerWidth() *
        $(".story_gallery_nav li").length;
      if (timelineWidth >= window.innerWidth) {
        $(".story_gallery_nav").css("overflow-x", "scroll");
        $(".story_gallery_nav").scrollLeft(
          $(".story_gallery_nav .is_selected").offset().left -
            (window.innerWidth - 66) / 2
        );
      } else {
        $(".story_gallery_nav").css("overflow-x", "hidden");
      }

      var fold_height =
        window.innerHeight -
        $(".header_top").innerHeight() -
        $(".top_banner").innerHeight();

      if (window.innerWidth > 768) {
        $(".product_description").find(".more_text").css("max-height", 217);
        show_more_height = 217;

        $(".product_zoom_block").height(
          $(".product_description").innerHeight()
        );

        $(".product_thumb").height($(".product_thumb").width());
        // $(".product_data").height(fold_height - 80);
        // console.log('fold_height - 80', fold_height);

        setTimeout(function () {
          if (fold_height > $(".product_description").height() + 40) {
            var margin_top =
              ($(".product_description").height() -
                $(".product_media").height()) /
              2;
          } else {
            var margin_top =
              (fold_height - $(".product_media").height()) / 2 - 40;
          }
          $(".product_media").css("margin-top", margin_top);
        }, 100);

        $(".product_thumbs_container").height(
          $(".product_image_container").height()
        );
        $(".product_zoom_container").height(
          $(".product_description").innerHeight()
        );

        $(".story_gallery_nav").height("inherit");
        $(".story_gallery").css("margin-top", "0");
      } else {
        if (window.innerWidth > 420) {
          $(".product_description").find(".more_text").css("max-height", 190);
          show_more_height = 190;
        } else {
          $(".product_description").find(".more_text").css("max-height", 170);
          show_more_height = 170;
        }
        $(".product_media").css("margin-top", "inherit");
        $(".product_zoom_block").css("height", "inherit");
        $(".product_thumbs_container").css("height", "inherit");
        $(".product_data").css("height", "inherit");

        $(".story_gallery_nav").height(
          $(".story_gallery_cell.is-selected .story_image").innerHeight() +
            $(".story_gallery_nav li").innerHeight() +
            2
        );
        $(".story_gallery").css(
          "margin-top",
          $(".story_gallery_nav li").innerHeight()
        );
      }

      /*if(window.innerWidth > 1280){
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2-50, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}
		else if(window.innerWidth > 1024  && window.innerWidth <= 1280){
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2-20, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}
		else{
			$('.zoom_shadow').css({'left': $('.zoom_block').innerWidth()/2+40, 'margin-left': -$('.zoom_block').innerWidth()/2});
		}*/

      if (
        $(".more_text .inner_text").innerHeight() >
        $(".more_text").innerHeight()
      ) {
        $(".show_more").fadeIn();
        $(".more_text").addClass("longtext");
      } else {
        $(".show_more").fadeOut();
        $(".more_text").removeClass("longtext");
      }

      var block_height = $(".filter_dropdown .tab_content.active ul").height();
      $(".filter_dropdown").height(block_height + 80);

      if ($(".home_fold_block").length) {
        if (!device.mobile()) {
          if (window.innerWidth > 768) {
            $(".home_fold_block, .home_fold_block .carousel-cell").height(
              window.innerHeight -
                $(".header_top").height() -
                $(".top_banner").height() -
                parseInt(window.innerHeight / 3)
            );
          } else {
            $(".home_fold_block .carousel-cell").height(
              window.innerHeight -
                $(".header_top").height() -
                $(".top_banner").height() -
                parseInt(window.innerHeight / 3)
            );
            $(".home_fold_block.mobile").css("height", "auto");
          }
        }
      }

      /*if(window.innerWidth > 920){
			$('.footer_subs').each(function(){
				$(this).width($(this).parent().width()-$(this).parent().find('span').width()-70);
			});
		}
		else{
			$('.footer_subs').css('width', 'inherit');
		}*/

      if ($(".filter_dropdown").length) {
        if (window.innerWidth < 640) {
          $(".filter_dropdown .tab_content > ul > li > span")
            .unbind("click")
            .click(function () {
              if ($(this).parent().hasClass("opened")) {
                $(this).parent().removeClass("opened");
                $(".filter_dropdown").css("height", block_height_resp + 65);
              } else {
                $(".filter_dropdown .tab_content > ul > li").removeClass(
                  "opened"
                );
                $(this).parent().addClass("opened");

                var li_height = "";
                $(this)
                  .parent()
                  .find("ul li")
                  .each(function (key, val) {
                    if (isEven(key)) {
                      li_height = (parseInt(li_height) || 0) + $(this).height();
                    }
                  });

                $(".filter_dropdown").css(
                  "height",
                  block_height_resp + 83 + li_height
                );
              }
            });
        }
      }

      if (window.innerWidth > 920 && $("body").hasClass("openednav")) {
        closeNav($carousel);
      }

      $(document)
        .unbind("click")
        .on("click touchstart", function (event) {
          if ($("body").hasClass("openednav")) {
            if (
              !$(event.target).closest(".main_menu_inner").length &&
              !$(event.target).closest(".menu_button").length
            ) {
              closeNav($carousel);
            }
          }
        });
    })
    .trigger("resize");

  if ($(".home_fold_block").length) {
    if (device.mobile()) {
      if (window.innerWidth < 768) {
        $(".home_fold_block .carousel-cell").css(
          "height",
          $(window).height() -
            $(".header_top").height() -
            $(".top_banner").height() +
            "px"
        );
        $(".home_fold_block.mobile").css("height", "auto");
      }
    }
  }

  if ($(".home_fold_block .carousel").length) {
    var $carousel = $(".home_fold_block .carousel").flickity({
      bgLazyLoad: true,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.2,
      autoPlay: true,
    });
  }

  $(".menu_button").click(function () {
    openNav($carousel);
  });
  $(".close_menu_button").click(function () {
    closeNav($carousel);
  });

  if (window.innerWidth < 480) {
    if ($(".login_form_block").length) {
      $('input[name="customer[password]"]').parent().addClass("active");
    }
  }

  if ($(".discount_info_popup")[0]) {
    setTimeout(function () {
      $(".discount_info_popup").addClass("opened");
    }, 3000);
  }

  if (typeof _compatible_products != "undefined") LoadCompatibleProducts();
});

function loadImage(elem, _cb) {
  var img = new Image();

  if ($(window).width() <= 480) {
    if (elem.attr("data-srcm")) {
      img.src = elem.attr("data-srcm");
    } else {
      img.src = elem.attr("data-src");
    }
  } else {
    img.src = elem.attr("data-src");
  }

  img.onload = function () {
    elem.addClass("loaded");
    elem.css("background-image", "url(" + img.src + ")");
    _cb();
  };
}
function loadAllBGImages(elems, _cb) {
  if (elems.length > 0) {
    var _cont = elems.length;
    var _curr = 0;
    elems.each(function () {
      loadImage($(this), function () {
        _curr++;
        if (_curr == _cont) {
          _cb();
        }
      });
    });
  } else {
    _cb();
  }
}

function loadShadowImage(elem) {
  var img = new Image();
  img.src = elem.find(".product_image_block img").attr("src");

  img.onload = function () {
    setTimeout(function () {
      elem.addClass("loaded");
      elem.find(".shadow_load").css("background-size", "100% 100%");
    }, 200);
  };
}

function parallax(bg, padding, step, position) {
  var scrolled = $(window).scrollTop();
  $("." + bg).css(position, -(scrolled * step) + padding + "px");
}

function openNav($carousel) {
  $("body").addClass("openednav");
  setTimeout(function () {
    if (window.innerWidth - $(".main_menu_inner").width() < 200) {
      $(".header .close_menu_button").css(
        "width",
        window.innerWidth - $(".main_menu_inner").width()
      );
    }
  }, 300);

  $(".basket_button_block").css("pointer-events", "none");

  if ($(".home_fold_block .carousel").length) {
    $carousel.flickity("stopPlayer");
  }
}

function closeNav($carousel) {
  $("body").removeClass("openednav");
  setTimeout(function () {
    $(".basket_button_block").css("pointer-events", "initial");
  }, 500);

  if ($(".home_fold_block .carousel").length) {
    $carousel.flickity("playPlayer");
  }
}

/*
equalheight = function(container){

	if(window.innerWidth>640){
		var currentTallest = 0,
		     currentRowStart = 0,
		     rowDivs = new Array(),
		     $el,
		     topPosition = 0;
		 $(container).each(function() {

		   $el = $(this);
		   $($el).height('auto')
		   topPostion = $el.position().top;

		   if (currentRowStart != topPostion) {
		     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		       rowDivs[currentDiv].height(currentTallest);
		     }
		     rowDivs.length = 0; // empty the array
		     currentRowStart = topPostion;
		     currentTallest = $el.height();
		     rowDivs.push($el);
		   } else {
		     rowDivs.push($el);
		     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
		  }
		   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
		     rowDivs[currentDiv].height(currentTallest);
		   }
		 });
	}
	else{
		$(container).height('inherit');
	}
}
*/

function LoadShopSocialJSON(_url, _id, _cb) {
  $.getJSON(_url, function (_socials) {
    var _items = [];
    for (var _i = 0; _i < _socials.length; _i++) {
      if (_socials[_i].id.toString() == _id.toString()) {
        _items = _socials[_i].items;
        break;
      }
    }
    _cb(_items);
  });
}
///////////////////////////////////////////////////
function ShopSocialCreate(_class) {
  if (__shop_social.length > 0) {
    var _image_slides = [];
    var _ind = 0;
    $(".shop_social." + _class + ' div[data-image="social"]').each(function (
      key,
      value
    ) {
      if (
        ((_class == "home" && key < 10) || (_class == "catalog" && key < 7)) &&
        __shop_social[_ind]
      ) {
        if (_image_slides.indexOf(__shop_social[_ind]["image"]) != -1) {
          for (var _i = _ind; _i < __shop_social.length; _i++) {
            if (_image_slides.indexOf(__shop_social[_i]["image"]) == -1) {
              _ind = _i;
              break;
            }
          }
        }
        _image_slides.push(__shop_social[_ind]["image"]);
        $(this)
          .css({
            "background-image": 'url("' + __shop_social[_ind]["image"] + '")',
          })
          .addClass("social_link")
          .attr("id", __shop_social[_ind]["pid"])
          .attr("data-type", _class)
          .attr("data-index", _ind);
        _ind++;
      } else {
        $(this).parents(".shop_social_block").hide();
      }
    });
  } else {
    $(".shop_social").hide();
  }
}
////////////////////////////////////////////////////////////

function CreateFilters() {
  $.getJSON(_filters_json_url, function (_all_filters) {
    _all_filters["genders"].map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_g").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_g ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k.toString() +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_g").length < 2) {
      $("#filter_g_ttl").hide();
    }

    _all_filters["technologys"].sort().map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_t").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_t ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k.toString() +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_t").length < 2) {
      $("#filter_t_ttl").hide();
    }

    _all_filters["colors"].sort().map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_c").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_c ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k.toString() +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_c").length < 2) {
      $("#filter_c_ttl").hide();
    }

    _all_filters["price_range"].map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_p").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_p ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k
                .toString()
                .replace("1", "$1")
                .replace("2", "$2")
                .replace("3", "$3")
                .replace("4", "$4")
                .replace("5", "$5")
                .replace("6", "$6")
                .replace("7", "$7")
                .replace("8", "$8")
                .replace("999", "$999")
                .replace("-99", "-$99")
                .replace("$2$5", "$25") +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_p").length < 2) {
      $("#filter_p_ttl").hide();
    }

    _all_filters["collection"].sort().map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_cl").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_cl ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k.toString() +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_cl").length < 2) {
      $("#filter_cl_ttl").hide();
    }

    _all_filters["size"].sort().map(function (_k) {
      for (var _i = 0; _i < _collection_tags.length; _i++) {
        if (_collection_tags[_i].tag.toString() == _k.toString()) {
          $("#filter_sz").append(
            '<li><a href="#" data-id="' +
              _collection_tags[_i].tag +
              '" class="filteringoption filter_sz ' +
              (_collection_tags[_i].active ? "active" : "") +
              '">' +
              _k.toString() +
              "</a></li>"
          );
          break;
        }
      }
    });

    if ($(".filter_sz").length < 2) {
      $("#filter_sz_ttl").hide();
    }

    var _hashed_tags = window.location.hash
      .replace("#", "")
      .replace(/%20/g, " ");

    if (_hashed_tags != "") {
      var _tags = _hashed_tags.split("+");
      if ($(".filter_g")[0]) {
        $(".filter_g").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_t")[0]) {
        $(".filter_t").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_c")[0]) {
        $(".filter_c").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_p")[0]) {
        $(".filter_p").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_cl")[0]) {
        $(".filter_cl").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }
      if ($(".filter_sz")[0]) {
        $(".filter_sz").each(function () {
          if (_tags.indexOf($(this).attr("data-id")) > -1)
            $(this).addClass("active");
        });
      }

      if ($(".collection_handle_seiko5sports").length) {
        setTimeout(function () {
          $("html, body").scrollTop($(".scrolltocol").offset().top);
          //$('html, body').animate({scrollTop: parseInt($(".scrolltocol").offset().top)}, 1000);
        }, 2200);
      }
    }

    if ($(".sortingoption.active")[0]) {
      var _typ = $(".sortingoption.active").hasClass("sorting-p")
        ? "Price"
        : "FEATURED";
      $(".sorting_shortcut").append(
        "<li>" +
          _typ +
          ": <span>" +
          $(".sortingoption.active").html() +
          '<a class="remove_selected_sorting" href="#"></a></span></li>'
      );
      $(".selected_filters").show();
      $(".sorting_shortcut_cont").css("display", "inline-block");
    }

    loadAllProducts();
  });
}
////////////////////////////////////////////////////////////////////////////

function loadAllProducts() {
  var _url = window.location.href.split("#")[0];
  $.ajax({
    url:
      _url +
      (_url.indexOf("?") > 0 ? "&" : "/?") +
      "page=" +
      _ajaxloadingpageid,

    type: "get",
    dataType: "html",
    success: function (response) {
      var result = $(".search_page_content")[0]
        ? $(response).find(".search_result_without_group")
        : $(response).find(".product_block_margin");
      var _prds = $(result).find(".product_item_for_filter");

      if (_prds.length > 0) {
        _prds.each(function () {
          if ($(".search_page_content")[0]) {
            $(".product_block_group_" + $(this).attr("data-group")).append(
              $(this)
            );
          } else {
            $(".product_block_margin").append($(this));
          }
        });

        if (_prds.length == 50) {
          _ajaxloadingpageid++;
          loadAllProducts();
        } else {
          Move_OutofStoke_to_bottom();
          MarkWishlist();
          StartFilter();
        }
      } else {
        Move_OutofStoke_to_bottom();
        MarkWishlist();
        StartFilter();
      }
    },
  });
}
/////////////////////////////////////////////////////////////////////
function Move_OutofStoke_to_bottom() {
  $(".product_item_for_filter").each(function () {
    if (!$(this).hasClass("p_is_av")) {
      $(".product_block_margin").append(this);
    }
  });
}

////////////////////////////////////////////////////////////////////////////

function StartFilter() {
  if ($(".product_item_for_filter").length > 0) {
    var _tags = [];
    var _tags_g = [];
    var _tags_t = [];
    var _tags_c = [];
    var _tags_p = [];
    var _tags_cl = [];
    var _tags_sz = [];
    if ($(".filteringoption")[0]) {
      $(".filteringoption").each(function () {
        if ($(this).hasClass("active")) {
          _tags.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_g"))
            _tags_g.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_t"))
            _tags_t.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_c"))
            _tags_c.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_p"))
            _tags_p.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_cl"))
            _tags_cl.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_sz"))
            _tags_sz.push($(this).attr("data-id"));
        }
      });
    }

    if (_collection_handle != "") {
      var _url = window.location.origin + "/collections/" + _collection_handle;
      if ($(".sortingoption.active")[0])
        _url = _url + "/?sort_by=" + $(".sortingoption.active").attr("data-id");

      if (_tags.length > 0) {
        _url = _url + "#" + _tags.join("+");

        $(".selected_filters").show();
        $(".filters_shortcut_cont").css("display", "inline-block");
        $(".filters_shortcut").empty();

        if (_tags_g.length > 0) {
          var _nel = $("<li>GENDER: </li>");
          _tags_g.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
        if (_tags_t.length > 0) {
          var _nel = $("<li>TECHNOLOGY: </li>");
          _tags_t.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
        if (_tags_c.length > 0) {
          var _nel = $("<li>COLOR: </li>");
          _tags_c.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
        if (_tags_p.length > 0) {
          var _nel = $("<li>PRICE: </li>");
          _tags_p.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
        if (_tags_cl.length > 0) {
          var _nel = $("<li>COLLETION: </li>");
          _tags_cl.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
        if (_tags_sz.length > 0) {
          var _nel = $("<li>SIZE: </li>");
          _tags_sz.map(function (_c) {
            _nel.append(
              "<span>" +
                _c +
                '<a class="remove_selected_filter" href="#"></a></span>'
            );
          });
          $(".filters_shortcut").append(_nel);
        }
      } else {
        $(".filters_shortcut_cont").hide();
        $(".filters_shortcut").empty();
        if (!$(".sortingoption.active")[0]) $(".selected_filters").hide();
      }

      history.pushState({}, "", _url);
    }
    var _countp = 0;

    $(".product_item_for_filter").removeClass("p_show").addClass("p_hide");
    for (var _i = 0; _i < $(".product_item_for_filter").length; _i++) {
      var _this = $(".product_item_for_filter")[_i];

      if (_tags.length > 0) {
        var _inds = 0;
        if (_tags_g.length > 0) {
          for (var _j = 0; _j < _tags_g.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_g[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_t.length > 0) {
          for (var _j = 0; _j < _tags_t.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_t[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_c.length > 0) {
          for (var _j = 0; _j < _tags_c.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_c[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_p.length > 0) {
          for (var _j = 0; _j < _tags_p.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_p[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }

        if (_tags_cl.length > 0) {
          for (var _j = 0; _j < _tags_cl.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_cl[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }

        if (_tags_sz.length > 0) {
          for (var _j = 0; _j < _tags_sz.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_sz[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }

        if (_inds == 6) {
          $(_this).removeClass("p_hide").addClass("p_show");
          if (!$(_this).find(".product_image_block_img").hasClass("loaded")) {
            $(_this)
              .find(".product_image_block_img")
              .attr(
                "src",
                $(_this).find(".product_image_block_img").attr("data-src")
              )
              .addClass("loaded");
          }
          _countp++;
        }
      } else {
        $(_this).removeClass("p_hide").addClass("p_show");
        if (!$(_this).find(".product_image_block_img").hasClass("loaded")) {
          $(_this)
            .find(".product_image_block_img")
            .attr(
              "src",
              $(_this).find(".product_image_block_img").attr("data-src")
            )
            .addClass("loaded");
        }
        _countp++;
      }

      if ($(".shadow_load").length) {
        loadShadowImage($(_this));
      }

      if (_countp == 20) break;
    }

    if (_countp == 0) {
      $(".no_products").show();
    } else {
      $(".no_products").hide();
    }

    if ($(".search_page_content")[0]) {
      var _activtbl = "seiko";
      if (!$(".group_page-page_seiko")[0]) {
        $(".no_page-page_seiko").show();
        $(".seiko_tab ").hide();
        _activtbl = "pulsar";
      }
      if (!$(".group_page-page_pulsar")[0]) {
        $(".no_page-page_pulsar").show();
        $(".pulsar_tab ").hide();
        _activtbl = _activtbl == "pulsar" ? "clocks" : "seiko";
      }
      if (!$(".group_page-page_clocks")[0]) {
        $(".no_page-page_clocks").show();
        $(".clocks_tab ").hide();
        _activtbl =
          _activtbl == "clocks" || _activtbl == "seiko" ? "seiko" : "pulsar";
      }

      $(".search_tab_content").removeClass("active");
      $(".search_tab_content." + _activtbl).addClass("active");

      if ($('.search_tabs .search_tab[data-tab="' + _activtbl + '"]').length) {
        $(".search_tab").removeClass("active");
        $('.search_tab[data-tab="' + _activtbl + '"]').addClass("active");
      } else {
        $('.search_tab[data-tab="seiko"]').addClass("active");
      }
      if (!$(".product_block")[0]) $(".search_tab_content.active").show();
    }

    $(".loadmore").hide();
    _loadingcollectionproducts = false;
  } else {
    $(".loadmore").hide();
    if ($(".search_page_content")[0]) {
      var _activtbl = "seiko";
      if (!$(".group_page-page_seiko")[0]) {
        $(".no_page-page_seiko").show();
        $(".seiko_tab ").hide();
        _activtbl = "pulsar";
      }
      if (!$(".group_page-page_pulsar")[0]) {
        $(".no_page-page_pulsar").show();
        $(".pulsar_tab ").hide();
        _activtbl = _activtbl == "pulsar" ? "clocks" : "seiko";
      }
      if (!$(".group_page-page_clocks")[0]) {
        $(".no_page-page_clocks").show();
        $(".clocks_tab ").hide();
        _activtbl =
          _activtbl == "clocks" || _activtbl == "seiko" ? "seiko" : "pulsar";
      }

      $(".search_tab_content").removeClass("active");
      $(".search_tab_content." + _activtbl).addClass("active");

      if ($('.search_tabs .search_tab[data-tab="' + _activtbl + '"]').length) {
        $(".search_tab").removeClass("active");
        $('.search_tab[data-tab="' + _activtbl + '"]').addClass("active");
      } else {
        $('.search_tab[data-tab="seiko"]').addClass("active");
      }
      if (!$(".product_block")[0]) $(".search_tab_content.active").show();
    }
  }
}
////////////////////////////////////////////////////////////////////////////

function NexstFilteredList() {
  if (_productslistshow * 20 <= $(".product_item_for_filter").length) {
    _productslistshow++;
    var _tags = [];
    var _tags_g = [];
    var _tags_t = [];
    var _tags_c = [];
    var _tags_p = [];
    var _tags_cl = [];
    var _tags_sz = [];
    if ($(".filteringoption")[0]) {
      $(".filteringoption").each(function () {
        if ($(this).hasClass("active")) {
          _tags.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_g"))
            _tags_g.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_t"))
            _tags_t.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_c"))
            _tags_c.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_p"))
            _tags_p.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_cl"))
            _tags_cl.push($(this).attr("data-id"));
          if ($(this).hasClass("filter_sz"))
            _tags_sz.push($(this).attr("data-id"));
        }
      });
    }

    var _countp = 0;

    for (
      var _i = (_productslistshow - 1) * 20;
      _i < $(".product_item_for_filter").length;
      _i++
    ) {
      var _this = $(".product_item_for_filter")[_i];
      if (_tags.length > 0) {
        var _inds = 0;
        if (_tags_g.length > 0) {
          for (var _j = 0; _j < _tags_g.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_g[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_t.length > 0) {
          for (var _j = 0; _j < _tags_t.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_t[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_c.length > 0) {
          for (var _j = 0; _j < _tags_c.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_c[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_p.length > 0) {
          for (var _j = 0; _j < _tags_p.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_p[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }
        if (_tags_cl.length > 0) {
          for (var _j = 0; _j < _tags_cl.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_cl[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }

        if (_tags_sz.length > 0) {
          for (var _j = 0; _j < _tags_sz.length; _j++) {
            if (
              $(_this)
                .attr("data-filters")
                .indexOf("|" + _tags_sz[_j].trim() + "|") > -1
            ) {
              _inds++;
              break;
            }
          }
        } else {
          _inds++;
        }

        if (_inds == 6) {
          $(_this).removeClass("p_hide").addClass("p_show");
          if (!$(_this).find(".product_image_block_img").hasClass("loaded")) {
            $(_this)
              .find(".product_image_block_img")
              .attr(
                "src",
                $(_this).find(".product_image_block_img").attr("data-src")
              )
              .addClass("loaded");
          }
          _countp++;
        }
      } else {
        $(_this).removeClass("p_hide").addClass("p_show");
        if (!$(_this).find(".product_image_block_img").hasClass("loaded")) {
          $(_this)
            .find(".product_image_block_img")
            .attr(
              "src",
              $(_this).find(".product_image_block_img").attr("data-src")
            )
            .addClass("loaded");
        }
        _countp++;
      }

      if ($(".shadow_load").length) {
        loadShadowImage($(_this));
      }

      if (_countp == 20 * _productslistshow) break;
    }
    _loadingcollectionproducts = false;
  }
}
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////
function PostRec(_url, _data, callback) {
  $.ajax({
    type: "POST",
    url: _url,
    dataType: "Json",
    data: _data,
  })
    .done(function (o) {
      callback(null, o);
    })
    .fail(function (e) {
      callback(e);
    });
}

function hashchangeSupport() {
  var hash = window.location.hash.substring(1);

  if (hash == "shipping") {
    hash = "privacy";
    setTimeout(function () {
      var targetOffset = $(".prvc_id_21").offset().top - 30;
      $("html, body").animate({ scrollTop: targetOffset }, 1000);
    }, 1000);
  } else if (hash == "privacy-c") {
    hash = "privacy";
    setTimeout(function () {
      var targetOffset = $(".prvc_id_8").offset().top - 30;
      $("html, body").animate({ scrollTop: targetOffset }, 1000);
    }, 1000);
  } else if (hash == "privacy") {
    hash = "privacy";
    setTimeout(function () {
      var targetOffset = $(".light_paragraph").offset().top - 100;
      $("html, body").animate({ scrollTop: targetOffset }, 1000);
    }, 1000);
  }

  $(".support_tab_block").removeClass("active");
  $(".support_tab_block." + hash).addClass("active");

  if ($('.support_tabs .support_tab[data-tab="' + hash + '"]').length) {
    $(".support_tab").removeClass("active");
    $('.support_tab[data-tab="' + hash + '"]').addClass("active");
  } else {
    $('.support_tab[data-tab="service"]').addClass("active");
  }
}

function hashchangeSearch() {
  var hash = window.location.hash.substring(1);
  $(".search_tab_content").removeClass("active");
  $(".search_tab_content." + hash).addClass("active");

  if ($('.search_tabs .search_tab[data-tab="' + hash + '"]').length) {
    $(".search_tab").removeClass("active");
    $('.search_tab[data-tab="' + hash + '"]').addClass("active");
  } else {
    $('.search_tab[data-tab="seiko"]').addClass("active");
  }
}
/////////////////////////////////////////////////////////////
function setPholder() {
  if (window.innerWidth > 480) {
    if ($(".pholder").length) {
      $(".pholder").each(function (key, value) {
        $(this)
          .parent()
          .find("input")
          .css({ "padding-top": 0, "padding-left": $(this).width() + 25 });
      });
    }
  } else {
    if (window.innerWidth > 420) {
      $(".form_block .pholder")
        .parent()
        .find("input")
        .css({ "padding-top": "12px", "padding-left": "12px" });
    } else {
      $(".form_block .pholder")
        .parent()
        .find("input")
        .css({ "padding-top": "11px", "padding-left": "8px" });
    }
    $(".promo_form_block .pholder")
      .parent()
      .find("input")
      .css({
        "padding-top": 0,
        "padding-left": $(".promo_form_block .pholder").width() + 25,
      });
  }
}

///////////////////////////////////////////////////////////////////////

var _loaded_index = 0;
var _wished_products_handles = [];
var _wished_products_products = [];

function LoadWishlistProduct() {
  $.ajax({
    type: "GET",
    url: "/products/" + _wished_products_handles[_loaded_index] + ".js",
    dataType: "json",
  })
    .done(function (product) {
      if (product.available) _wished_products_products.push(product);
      _loaded_index++;
      if (
        _loaded_index < _wished_products_handles.length &&
        _wished_products_products.length < 20
      ) {
        LoadWishlistProduct();
      } else {
        ShowWishList();
      }
      contentHeight();
      //cartItemPhotoWidth();
    })
    .fail(function (e) {
      _loaded_index++;
      if (
        _loaded_index < _wished_products_handles.length &&
        _wished_products_products.length < 20
      ) {
        LoadWishlistProduct();
      } else {
        ShowWishList();
      }
    });
}

///////////////////////////////////////////////////////////////
function ShowWishList() {
  if (_wished_products_products.length > 0) {
    _wished_products_products.map(function (_i) {
      console.log("i", _i);
      var _neimg = _i.featured_image.split(".");
      _neimg[_neimg.length - 2] = _neimg[_neimg.length - 2] + "_200x300";
      var _img = _neimg.join(".");
      var _prcc =
        (_i.price / 100).toString().indexOf(".") > 0
          ? (_i.price / 100).toString().replace(".", "<sup>")
          : (_i.price / 100).toString() + "<sup>";

      $("#wishlist_content_list").append(
        '<tr class="cart_item" id="' +
          _i.variants[0].id +
          '"  data-handle="' +
          _i.handle +
          '">' +
          /*'<td class="cart_item_logo">'+
          '<a class="cart_item_title" href="product_seiko.html">'+_i.title+'</a>'+
           '</td>'+*/

          '<td class="cart_item_product"><a class="cart_item_photo" href="' +
          _i.url +
          '"><img src="' +
          _img +
          '" alt="' +
          _i.title +
          '" title="' +
          _i.title +
          '" /></a></td>' +
          '<td class="shopping_cart_cols">' +
          "<table>" +
          "<tr>" +
          '<td colspan="3">' +
          '<span class="cart_item_logo_wrapper">' +
          '<a class="cart_item_title" href="' +
          _i.url +
          '">' +
          _i.title +
          "</a>" +
          "</span>" +
          "</td>" +
          "</tr>" +
          "<tr>" +
          '<td class="cart_item_total"><span class="line_total">$' +
          _prcc +
          "</sup></span></td>" +
          '<td class="cart_item_addbag"><button type="submit" class="standard_button wishlist_add_to_cart" data-handle="' +
          _i.handle +
          '" data-id="' +
          _i.variants[0].id +
          '">ADD TO CART</button></td>' +
          '<td class="cart_item_remove"><a href="#" class="cart_item_remove_url wishlist_remove_item" data-id="' +
          _i.variants[0].id +
          '" data-handle="' +
          _i.handle +
          '" title="Remove"></a></td>' +
          "</tr>" +
          "</table>" +
          "</td>" +
          "</tr>"
      );
    });
    $.cookie("wishlist", _wished_products_handles.join(","), { path: "/" });
    $(".wishlist_content").show();
  } else {
    $(".wishlist_empty").show();
  }
  $(".loadmore").hide();
}

///////////////////////////////////////////////////////////
function MarkWishlist() {
  if (_wished_products_handles.length > 0) {
    $(".product_item_for_filter").each(function () {
      var __this = $(this);
      if (__this.find(".wishlist")[0]) {
        var _handl = __this.find(".wishlist").attr("data-handle").toString();
        if (_wished_products_handles.indexOf(_handl) > -1)
          __this.find(".wishlist").addClass("active");
      }
    });
  }
}
//////////////////////////////////////////////////////////////
function contentHeight() {
  if (
    $(".content").height() <
    window.innerHeight - $(".header").innerHeight() - $(".footer").innerHeight()
  ) {
    $(".content").height(
      window.innerHeight -
        $(".header").innerHeight() -
        $(".footer").innerHeight()
    );

    if ($(".support_block").length) {
      $(".support_block").height(
        $(".content").height() -
          $(".support_tabs").height() -
          $(".section_title").height() -
          30
      );
    }
  } else {
    $(".content").height("inherit");

    if ($(".support_block").length) {
      $(".support_block").height("inherit");
    }
  }
}
/////////////////////////////////////////////////////////////////////
function cartItemPhotoWidth() {
  if ($(".cart_item_photo").length) {
    $(".cart_item_photo").each(function () {
      var _thisimg = $(this);
      setTimeout(function () {
        if (window.innerWidth > 768) {
          if (_thisimg.find("img").width() < 150) {
            _thisimg.width(_thisimg.find("img").width() + 40);
          } else {
            _thisimg.width(_thisimg.find("img").width());
          }
        } else {
          if (_thisimg.find("img").width() < 70) {
            _thisimg.width(_thisimg.find("img").width() + 20);
          } else {
            _thisimg.width(_thisimg.find("img").width());
          }
        }
      }, 100);
    });
  }
}
////////////////////////////////////////////////////////////////////////
var _allmanuals = {};
function LoadManuals() {
  $.ajax({
    type: "GET",
    url: _products_manuals_json_url,
    dataType: "json",
  })
    .done(function (_manuals) {
      _allmanuals = _manuals;
    })
    .fail(function (e) {
      console.loog(e);
    });
}
////////////////////////////////////////////////////////////////////////
function SearchManuals(_val) {
  $(".download_manual").css("display", "none");
  $(".no_manual_found").css("display", "none");
  var _findmanual = false;
  for (var _key in _allmanuals) {
    for (var _v = 0; _v < _allmanuals[_key].length; _v++) {
      if (_allmanuals[_key][_v].toLowerCase() == _val.toLowerCase()) {
        $(".download_manual").html("DOWNLOAD MANUAL");
        $(".download_manual").attr(
          "href",
          "http://loremipsumcorp.com/seiko_shopify_b2b_data/watch-manuals/" +
            _key +
            ".pdf"
        );
        $(".download_manual").css("display", "block");
        _findmanual = true;
        break;
      }
    }
    if (_findmanual) break;
  }
  if (!_findmanual) {
    $(".no_manual_found").css("display", "block");
  }
}

function isEven(n) {
  n = Number(n);
  return n === 0 || !!(n && !(n % 2));
}
///////////////////////////////////////////////////////////////////////
function load_all_social_product_images() {
  $(".popup_product_image_block").each(function () {
    var _this = $(this);
    var _src = _this.find(".spinner").attr("data-src");
    var img = new Image();
    img.src = _src;
    img.onload = function () {
      _this
        .html('<img src="' + _src + '" alt="" title="" class="imageforload" />')
        .css("background-size", "100% 100%");
    };
  });
}
/////////////////////////////////////////////////////////////////
function PriceFormatting(_prc) {
  var _nprc = _prc.toString().split(".")[0];
  if (_nprc.length > 3) {
    if (_nprc.length == 4) {
      _nprc = _nprc.substr(0, 1) + "," + _nprc.substr(1);
    } else if (_nprc.length == 5) {
      _nprc = _nprc.substr(0, 2) + "," + _nprc.substr(2);
    } else if (_nprc.length == 6) {
      _nprc = _nprc.substr(0, 3) + "," + _nprc.substr(3);
    }
  }
  if (_prc.toString().split(".").length > 1) {
    if (_prc.toString().split(".")[1] != "00") {
      _nprc = _nprc + "<sup>." + _prc.toString().split(".")[1] + "</sup>";
    }
  }
  return _nprc;
}
////////////////////////////////////////////////////////////////////////////
function LoadCompatibleProducts() {
  var _comm = "";
  for (var _i = 0; _i < _compatible_products.length; _i++) {
    _comm +=
      _i > 0
        ? " OR handle:" + _compatible_products[_i]
        : "handle:" + _compatible_products[_i];
  }
  $.ajax({
    url: decodeURI("/search.js?view=products.handle&q=" + _comm),
    type: "get",
    dataType: "html",
    success: function (response) {
      $("#compatibleproductslist").append(response);
      $("#compatibleproductslist").append('<span class="cb"></span>');
    },
  });
}

function paralaxCollection5() {
  var elem = $(".img_block5");
  var wheight = $(window).height();
  var scrolling = $(window).scrollTop();
  elem.each(function () {
    var $this = $(this);
    var offset = $this.offset().top;
    var height = $this.height();
    var transform = 0;
    if (scrolling + wheight >= offset) {
      transform = Math.round(
        (wheight + height - (offset + height - scrolling)) /
          ((wheight + height) / 100)
      );
      if (scrolling >= offset + height) {
        transform = 100;
      }
    }
    $this
      .find("div")
      .css({ "background-position": "center " + transform + "%" });
  });
}

const rangeInput = document.querySelectorAll(".range-input input"),
  priceInput = document.querySelectorAll(".price-input input"),
  range = document.querySelector(".slider .progress");
let priceGap = 1000;

priceInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minPrice = parseInt(priceInput[0].value),
      maxPrice = parseInt(priceInput[1].value);

    if (maxPrice - minPrice >= priceGap && maxPrice <= rangeInput[1].max) {
      if (e.target.className === "input-min") {
        rangeInput[0].value = minPrice;
        range.style.left = (minPrice / rangeInput[0].max) * 100 + "%";
      } else {
        rangeInput[1].value = maxPrice;
        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
      }
    }
  });
});

rangeInput.forEach((input) => {
  input.addEventListener("input", (e) => {
    let minVal = parseInt(rangeInput[0].value),
      maxVal = parseInt(rangeInput[1].value);

    if (maxVal - minVal < priceGap) {
      if (e.target.className === "range-min") {
        rangeInput[0].value = maxVal - priceGap;
      } else {
        rangeInput[1].value = minVal + priceGap;
      }
    } else {
      priceInput[0].value = minVal;
      priceInput[1].value = maxVal;
      range.style.left = (minVal / rangeInput[0].max) * 100 + "%";
      range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
    }
  });
});

$("body").on("click", ".productinfo_add_to_cart", function (e) {
  e.preventDefault();

  var productId = $(this).data("id");
  var discountedPrice = $(this).data("discount");
  var customerId = $(this).data("customer");
  var productTag = $(this).attr("product-tag");
  var collectionTag = $(this).attr("collection-tag"); // Retrieve the collection-tag attribute

  var customProperties = {
    dis_price: discountedPrice,
    customer_id: customerId,
    product_tag: productTag,
    collection_tag: collectionTag, // Include the collection-tag in the custom properties
  };

  // Use customProperties as needed
});

// $("body").on("click", ".collection", function (e) {
//     e.preventDefault();

//     var collectionHandle = $(this).data("data-collection-tag"); // Retrieve the collection handle from the data attribute

//     var customProperties = {
//       collection_handle: collectionHandle
//     };

//   console.log('customProperties', customProperties);

//     // Use customProperties as needed
// });
